var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/lodash/lodash.js
var require_lodash = __commonJS({
  "../../node_modules/lodash/lodash.js"(exports, module) {
    "use strict";
    (function() {
      var undefined2;
      var VERSION = "4.17.21";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT2 = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN2 = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        ["ary", WRAP_ARY_FLAG],
        ["bind", WRAP_BIND_FLAG],
        ["bindKey", WRAP_BIND_KEY_FLAG],
        ["curry", WRAP_CURRY_FLAG],
        ["curryRight", WRAP_CURRY_RIGHT_FLAG],
        ["flip", WRAP_FLIP_FLAG],
        ["partial", WRAP_PARTIAL_FLAG],
        ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
        ["rearg", WRAP_REARG_FLAG]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag2 = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag2 = "[object Symbol]", undefinedTag2 = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart2 = /^\s+/;
      var reWhitespace2 = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex2 = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary2 = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal2 = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag2] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "\xC0": "A",
        "\xC1": "A",
        "\xC2": "A",
        "\xC3": "A",
        "\xC4": "A",
        "\xC5": "A",
        "\xE0": "a",
        "\xE1": "a",
        "\xE2": "a",
        "\xE3": "a",
        "\xE4": "a",
        "\xE5": "a",
        "\xC7": "C",
        "\xE7": "c",
        "\xD0": "D",
        "\xF0": "d",
        "\xC8": "E",
        "\xC9": "E",
        "\xCA": "E",
        "\xCB": "E",
        "\xE8": "e",
        "\xE9": "e",
        "\xEA": "e",
        "\xEB": "e",
        "\xCC": "I",
        "\xCD": "I",
        "\xCE": "I",
        "\xCF": "I",
        "\xEC": "i",
        "\xED": "i",
        "\xEE": "i",
        "\xEF": "i",
        "\xD1": "N",
        "\xF1": "n",
        "\xD2": "O",
        "\xD3": "O",
        "\xD4": "O",
        "\xD5": "O",
        "\xD6": "O",
        "\xD8": "O",
        "\xF2": "o",
        "\xF3": "o",
        "\xF4": "o",
        "\xF5": "o",
        "\xF6": "o",
        "\xF8": "o",
        "\xD9": "U",
        "\xDA": "U",
        "\xDB": "U",
        "\xDC": "U",
        "\xF9": "u",
        "\xFA": "u",
        "\xFB": "u",
        "\xFC": "u",
        "\xDD": "Y",
        "\xFD": "y",
        "\xFF": "y",
        "\xC6": "Ae",
        "\xE6": "ae",
        "\xDE": "Th",
        "\xFE": "th",
        "\xDF": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt2 = parseInt;
      var freeGlobal2 = typeof global == "object" && global && global.Object === Object && global;
      var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
      var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal2.process;
      var nodeUtil = function() {
        try {
          var types = freeModule && freeModule.require && freeModule.require("util").types;
          if (types) {
            return types;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {
        }
      }();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          var value = array[index];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }
      function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (!predicate(array[index], index, array)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }
      function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (comparator(value, array[index])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while (++index < length) {
          result[index] = iteratee(array[index], index, array);
        }
        return result;
      }
      function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while (++index < length) {
          array[offset + index] = values[index];
        }
        return array;
      }
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[++index];
        }
        while (++index < length) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }
        return accumulator;
      }
      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
      }
      function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (predicate(array[index], index, array)) {
            return true;
          }
        }
        return false;
      }
      var asciiSize = baseProperty("length");
      function asciiToArray(string) {
        return string.split("");
      }
      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }
      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection2) {
          if (predicate(value, key, collection2)) {
            result = key;
            return false;
          }
        });
        return result;
      }
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }
        return -1;
      }
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (comparator(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function baseIsNaN(value) {
        return value !== value;
      }
      function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN2;
      }
      function baseProperty(key) {
        return function(object) {
          return object == null ? undefined2 : object[key];
        };
      }
      function basePropertyOf(object) {
        return function(key) {
          return object == null ? undefined2 : object[key];
        };
      }
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection2);
        });
        return accumulator;
      }
      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
          array[length] = array[length].value;
        }
        return array;
      }
      function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while (++index < length) {
          var current = iteratee(array[index]);
          if (current !== undefined2) {
            result = result === undefined2 ? current : result + current;
          }
        }
        return result;
      }
      function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while (++index < n) {
          result[index] = iteratee(index);
        }
        return result;
      }
      function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
          return [key, object[key]];
        });
      }
      function baseTrim2(string) {
        return string ? string.slice(0, trimmedEndIndex2(string) + 1).replace(reTrimStart2, "") : string;
      }
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      function baseValues(object, props) {
        return arrayMap(props, function(key) {
          return object[key];
        });
      }
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while (length--) {
          if (array[length] === placeholder) {
            ++result;
          }
        }
        return result;
      }
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      function getValue(object, key) {
        return object == null ? undefined2 : object[key];
      }
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }
      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }
      function iteratorToArray(iterator) {
        var data, result = [];
        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }
        return result;
      }
      function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
          result[++index] = [key, value];
        });
        return result;
      }
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (value === placeholder || value === PLACEHOLDER) {
            array[index] = PLACEHOLDER;
            result[resIndex++] = index;
          }
        }
        return result;
      }
      function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index] = value;
        });
        return result;
      }
      function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index] = [value, value];
        });
        return result;
      }
      function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }
        return -1;
      }
      function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while (index--) {
          if (array[index] === value) {
            return index;
          }
        }
        return index;
      }
      function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
      }
      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }
      function trimmedEndIndex2(string) {
        var index = string.length;
        while (index-- && reWhitespace2.test(string.charAt(index))) {
        }
        return index;
      }
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string)) {
          ++result;
        }
        return result;
      }
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }
      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }
      var runInContext = function runInContext2(context) {
        context = context == null ? root2 : _2.defaults(root2.Object(), context, _2.pick(root2, contextProps));
        var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
        var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto3 = Object2.prototype;
        var coreJsData = context["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty2 = objectProto3.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = function() {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid ? "Symbol(src)_1." + uid : "";
        }();
        var nativeObjectToString3 = objectProto3.toString;
        var objectCtorString = funcToString.call(Object2);
        var oldDash = root2._;
        var reIsNative = RegExp2(
          "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        );
        var Buffer2 = moduleExports ? context.Buffer : undefined2, Symbol3 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined2, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto3.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol3 ? Symbol3.isConcatSpreadable : undefined2, symIterator = Symbol3 ? Symbol3.iterator : undefined2, symToStringTag3 = Symbol3 ? Symbol3.toStringTag : undefined2;
        var defineProperty = function() {
          try {
            var func = getNative(Object2, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e) {
          }
        }();
        var ctxClearTimeout = context.clearTimeout !== root2.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root2.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root2.setTimeout && context.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined2, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax2 = Math2.max, nativeMin2 = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
        var metaMap = WeakMap && new WeakMap();
        var realNames = {};
        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        var symbolProto = Symbol3 ? Symbol3.prototype : undefined2, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined2, symbolToString = symbolProto ? symbolProto.toString : undefined2;
        function lodash(value) {
          if (isObjectLike2(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty2.call(value, "__wrapped__")) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        var baseCreate = function() {
          function object() {
          }
          return function(proto) {
            if (!isObject2(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object.prototype = proto;
            var result2 = new object();
            object.prototype = undefined2;
            return result2;
          };
        }();
        function baseLodash() {
        }
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined2;
        }
        lodash.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "escape": reEscape,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "evaluate": reEvaluate,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "interpolate": reInterpolate,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          "variable": "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          "imports": {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            "_": lodash
          }
        };
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result2 = new LazyWrapper(this.__wrapped__);
          result2.__actions__ = copyArray(this.__actions__);
          result2.__dir__ = this.__dir__;
          result2.__filtered__ = this.__filtered__;
          result2.__iteratees__ = copyArray(this.__iteratees__);
          result2.__takeCount__ = this.__takeCount__;
          result2.__views__ = copyArray(this.__views__);
          return result2;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result2 = new LazyWrapper(this);
            result2.__dir__ = -1;
            result2.__filtered__ = true;
          } else {
            result2 = this.clone();
            result2.__dir__ *= -1;
          }
          return result2;
        }
        function lazyValue() {
          var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin2(length, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result2 = [];
          outer:
            while (length-- && resIndex < takeCount) {
              index += dir;
              var iterIndex = -1, value = array[index];
              while (++iterIndex < iterLength) {
                var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
                if (type == LAZY_MAP_FLAG) {
                  value = computed;
                } else if (!computed) {
                  if (type == LAZY_FILTER_FLAG) {
                    continue outer;
                  } else {
                    break outer;
                  }
                }
              }
              result2[resIndex++] = value;
            }
          return result2;
        }
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        function hashDelete(key) {
          var result2 = this.has(key) && delete this.__data__[key];
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result2 = data[key];
            return result2 === HASH_UNDEFINED ? undefined2 : result2;
          }
          return hasOwnProperty2.call(data, key) ? data[key] : undefined2;
        }
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined2 : hasOwnProperty2.call(data, key);
        }
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined2 ? HASH_UNDEFINED : value;
          return this;
        }
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        function listCacheDelete(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index, 1);
          }
          --this.size;
          return true;
        }
        function listCacheGet(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          return index < 0 ? undefined2 : data[index][1];
        }
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        function listCacheSet(key, value) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index][1] = value;
          }
          return this;
        }
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map || ListCache)(),
            "string": new Hash()
          };
        }
        function mapCacheDelete(key) {
          var result2 = getMapData(this, key)["delete"](key);
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        function mapCacheSet(key, value) {
          var data = getMapData(this, key), size2 = data.size;
          data.set(key, value);
          this.size += data.size == size2 ? 0 : 1;
          return this;
        }
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        function SetCache(values2) {
          var index = -1, length = values2 == null ? 0 : values2.length;
          this.__data__ = new MapCache();
          while (++index < length) {
            this.add(values2[index]);
          }
        }
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        function stackDelete(key) {
          var data = this.__data__, result2 = data["delete"](key);
          this.size = data.size;
          return result2;
        }
        function stackGet(key) {
          return this.__data__.get(key);
        }
        function stackHas(key) {
          return this.__data__.has(key);
        }
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function arraySample(array) {
          var length = array.length;
          return length ? array[baseRandom(0, length - 1)] : undefined2;
        }
        function arraySampleSize(array, n) {
          return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }
        function assignMergeValue(object, key, value) {
          if (value !== undefined2 && !eq(object[key], value) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assignValue(object, key, value) {
          var objValue = object[key];
          if (!(hasOwnProperty2.call(object, key) && eq(objValue, value)) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        function baseAggregator(collection, setter, iteratee2, accumulator) {
          baseEach(collection, function(value, key, collection2) {
            setter(accumulator, value, iteratee2(value), collection2);
          });
          return accumulator;
        }
        function baseAssign(object, source) {
          return object && copyObject(source, keys(source), object);
        }
        function baseAssignIn(object, source) {
          return object && copyObject(source, keysIn(source), object);
        }
        function baseAssignValue(object, key, value) {
          if (key == "__proto__" && defineProperty) {
            defineProperty(object, key, {
              "configurable": true,
              "enumerable": true,
              "value": value,
              "writable": true
            });
          } else {
            object[key] = value;
          }
        }
        function baseAt(object, paths) {
          var index = -1, length = paths.length, result2 = Array2(length), skip = object == null;
          while (++index < length) {
            result2[index] = skip ? undefined2 : get(object, paths[index]);
          }
          return result2;
        }
        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined2) {
              number = number <= upper ? number : upper;
            }
            if (lower !== undefined2) {
              number = number >= lower ? number : lower;
            }
          }
          return number;
        }
        function baseClone(value, bitmask, customizer, key, object, stack) {
          var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result2 = object ? customizer(value, key, object, stack) : customizer(value);
          }
          if (result2 !== undefined2) {
            return result2;
          }
          if (!isObject2(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result2 = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result2);
            }
          } else {
            var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object) {
              result2 = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object ? value : {};
              }
              result2 = initCloneByTag(value, tag, isDeep);
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result2);
          if (isSet(value)) {
            value.forEach(function(subValue) {
              result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap(value)) {
            value.forEach(function(subValue, key2) {
              result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined2 : keysFunc(value);
          arrayEach(props || value, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value[key2];
            }
            assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
          return result2;
        }
        function baseConforms(source) {
          var props = keys(source);
          return function(object) {
            return baseConformsTo(object, source, props);
          };
        }
        function baseConformsTo(object, source, props) {
          var length = props.length;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (length--) {
            var key = props[length], predicate = source[key], value = object[key];
            if (value === undefined2 && !(key in object) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          return setTimeout2(function() {
            func.apply(undefined2, args);
          }, wait);
        }
        function baseDifference(array, values2, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
          if (!length) {
            return result2;
          }
          if (iteratee2) {
            values2 = arrayMap(values2, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values2.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values2 = new SetCache(values2);
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 == null ? value : iteratee2(value);
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while (valuesIndex--) {
                  if (values2[valuesIndex] === computed) {
                    continue outer;
                  }
                }
                result2.push(value);
              } else if (!includes2(values2, computed, comparator)) {
                result2.push(value);
              }
            }
          return result2;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result2 = true;
          baseEach(collection, function(value, index, collection2) {
            result2 = !!predicate(value, index, collection2);
            return result2;
          });
          return result2;
        }
        function baseExtremum(array, iteratee2, comparator) {
          var index = -1, length = array.length;
          while (++index < length) {
            var value = array[index], current = iteratee2(value);
            if (current != null && (computed === undefined2 ? current === current && !isSymbol2(current) : comparator(current, computed))) {
              var computed = current, result2 = value;
            }
          }
          return result2;
        }
        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined2 || end > length ? length : toInteger(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array[start++] = value;
          }
          return array;
        }
        function baseFilter(collection, predicate) {
          var result2 = [];
          baseEach(collection, function(value, index, collection2) {
            if (predicate(value, index, collection2)) {
              result2.push(value);
            }
          });
          return result2;
        }
        function baseFlatten(array, depth, predicate, isStrict, result2) {
          var index = -1, length = array.length;
          predicate || (predicate = isFlattenable);
          result2 || (result2 = []);
          while (++index < length) {
            var value = array[index];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                baseFlatten(value, depth - 1, predicate, isStrict, result2);
              } else {
                arrayPush(result2, value);
              }
            } else if (!isStrict) {
              result2[result2.length] = value;
            }
          }
          return result2;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object, iteratee2) {
          return object && baseFor(object, iteratee2, keys);
        }
        function baseForOwnRight(object, iteratee2) {
          return object && baseForRight(object, iteratee2, keys);
        }
        function baseFunctions(object, props) {
          return arrayFilter(props, function(key) {
            return isFunction(object[key]);
          });
        }
        function baseGet(object, path) {
          path = castPath(path, object);
          var index = 0, length = path.length;
          while (object != null && index < length) {
            object = object[toKey(path[index++])];
          }
          return index && index == length ? object : undefined2;
        }
        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
          var result2 = keysFunc(object);
          return isArray(object) ? result2 : arrayPush(result2, symbolsFunc(object));
        }
        function baseGetTag2(value) {
          if (value == null) {
            return value === undefined2 ? undefinedTag2 : nullTag2;
          }
          return symToStringTag3 && symToStringTag3 in Object2(value) ? getRawTag2(value) : objectToString2(value);
        }
        function baseGt(value, other) {
          return value > other;
        }
        function baseHas(object, key) {
          return object != null && hasOwnProperty2.call(object, key);
        }
        function baseHasIn(object, key) {
          return object != null && key in Object2(object);
        }
        function baseInRange(number, start, end) {
          return number >= nativeMin2(start, end) && number < nativeMax2(start, end);
        }
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee2) {
              array = arrayMap(array, baseUnary(iteratee2));
            }
            maxLength = nativeMin2(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined2;
          }
          array = arrays[0];
          var index = -1, seen = caches[0];
          outer:
            while (++index < length && result2.length < maxLength) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
                othIndex = othLength;
                while (--othIndex) {
                  var cache = caches[othIndex];
                  if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                    continue outer;
                  }
                }
                if (seen) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseInverter(object, setter, iteratee2, accumulator) {
          baseForOwn(object, function(value, key, object2) {
            setter(accumulator, iteratee2(value), key, object2);
          });
          return accumulator;
        }
        function baseInvoke(object, path, args) {
          path = castPath(path, object);
          object = parent(object, path);
          var func = object == null ? object : object[toKey(last(path))];
          return func == null ? undefined2 : apply(func, object, args);
        }
        function baseIsArguments(value) {
          return isObjectLike2(value) && baseGetTag2(value) == argsTag;
        }
        function baseIsArrayBuffer(value) {
          return isObjectLike2(value) && baseGetTag2(value) == arrayBufferTag;
        }
        function baseIsDate(value) {
          return isObjectLike2(value) && baseGetTag2(value) == dateTag;
        }
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike2(value) && !isObjectLike2(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        function baseIsMap(value) {
          return isObjectLike2(value) && getTag(value) == mapTag;
        }
        function baseIsMatch(object, source, matchData, customizer) {
          var index = matchData.length, length = index, noCustomizer = !customizer;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (index--) {
            var data = matchData[index];
            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
              return false;
            }
          }
          while (++index < length) {
            data = matchData[index];
            var key = data[0], objValue = object[key], srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined2 && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result2 = customizer(objValue, srcValue, key, object, source, stack);
              }
              if (!(result2 === undefined2 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIsNative(value) {
          if (!isObject2(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        function baseIsRegExp(value) {
          return isObjectLike2(value) && baseGetTag2(value) == regexpTag;
        }
        function baseIsSet(value) {
          return isObjectLike2(value) && getTag(value) == setTag;
        }
        function baseIsTypedArray(value) {
          return isObjectLike2(value) && isLength(value.length) && !!typedArrayTags[baseGetTag2(value)];
        }
        function baseIteratee(value) {
          if (typeof value == "function") {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (typeof value == "object") {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }
          var result2 = [];
          for (var key in Object2(object)) {
            if (hasOwnProperty2.call(object, key) && key != "constructor") {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseKeysIn(object) {
          if (!isObject2(object)) {
            return nativeKeysIn(object);
          }
          var isProto = isPrototype(object), result2 = [];
          for (var key in object) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object, key)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseLt(value, other) {
          return value < other;
        }
        function baseMap(collection, iteratee2) {
          var index = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value, key, collection2) {
            result2[++index] = iteratee2(value, key, collection2);
          });
          return result2;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function(object) {
            var objValue = get(object, path);
            return objValue === undefined2 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        function baseMerge(object, source, srcIndex, customizer, stack) {
          if (object === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject2(srcValue)) {
              baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined2;
              if (newValue === undefined2) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          }, keysIn);
        }
        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined2;
          var isCommon = newValue === undefined2;
          if (isCommon) {
            var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject2(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object, key, newValue);
        }
        function baseNth(array, n) {
          var length = array.length;
          if (!length) {
            return;
          }
          n += n < 0 ? length : 0;
          return isIndex(n, length) ? array[n] : undefined2;
        }
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray(iteratee2)) {
                return function(value) {
                  return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [identity];
          }
          var index = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result2 = baseMap(collection, function(value, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value);
            });
            return { "criteria": criteria, "index": ++index, "value": value };
          });
          return baseSortBy(result2, function(object, other) {
            return compareMultiple(object, other, orders);
          });
        }
        function basePick(object, paths) {
          return basePickBy(object, paths, function(value, path) {
            return hasIn(object, path);
          });
        }
        function basePickBy(object, paths, predicate) {
          var index = -1, length = paths.length, result2 = {};
          while (++index < length) {
            var path = paths[index], value = baseGet(object, path);
            if (predicate(value, path)) {
              baseSet(result2, castPath(path, object), value);
            }
          }
          return result2;
        }
        function basePropertyDeep(path) {
          return function(object) {
            return baseGet(object, path);
          };
        }
        function basePullAll(array, values2, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values2.length, seen = array;
          if (array === values2) {
            values2 = copyArray(values2);
          }
          if (iteratee2) {
            seen = arrayMap(array, baseUnary(iteratee2));
          }
          while (++index < length) {
            var fromIndex = 0, value = values2[index], computed = iteratee2 ? iteratee2(value) : value;
            while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }
        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0, lastIndex = length - 1;
          while (length--) {
            var index = indexes[length];
            if (length == lastIndex || index !== previous) {
              var previous = index;
              if (isIndex(index)) {
                splice.call(array, index, 1);
              } else {
                baseUnset(array, index);
              }
            }
          }
          return array;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start, end, step, fromRight) {
          var index = -1, length = nativeMax2(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
          while (length--) {
            result2[fromRight ? length : ++index] = start;
            start += step;
          }
          return result2;
        }
        function baseRepeat(string, n) {
          var result2 = "";
          if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
            return result2;
          }
          do {
            if (n % 2) {
              result2 += string;
            }
            n = nativeFloor(n / 2);
            if (n) {
              string += string;
            }
          } while (n);
          return result2;
        }
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + "");
        }
        function baseSample(collection) {
          return arraySample(values(collection));
        }
        function baseSampleSize(collection, n) {
          var array = values(collection);
          return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        function baseSet(object, path, value, customizer) {
          if (!isObject2(object)) {
            return object;
          }
          path = castPath(path, object);
          var index = -1, length = path.length, lastIndex = length - 1, nested = object;
          while (nested != null && ++index < length) {
            var key = toKey(path[index]), newValue = value;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object;
            }
            if (index != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined2;
              if (newValue === undefined2) {
                newValue = isObject2(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object;
        }
        var baseSetData = !metaMap ? identity : function(func, data) {
          metaMap.set(func, data);
          return func;
        };
        var baseSetToString = !defineProperty ? identity : function(func, string) {
          return defineProperty(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        function baseSlice(array, start, end) {
          var index = -1, length = array.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result2 = Array2(length);
          while (++index < length) {
            result2[index] = array[index + start];
          }
          return result2;
        }
        function baseSome(collection, predicate) {
          var result2;
          baseEach(collection, function(value, index, collection2) {
            result2 = predicate(value, index, collection2);
            return !result2;
          });
          return !!result2;
        }
        function baseSortedIndex(array, value, retHighest) {
          var low = 0, high = array == null ? low : array.length;
          if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed = array[mid];
              if (computed !== null && !isSymbol2(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value, identity, retHighest);
        }
        function baseSortedIndexBy(array, value, iteratee2, retHighest) {
          var low = 0, high = array == null ? 0 : array.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee2(value);
          var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol2(value), valIsUndefined = value === undefined2;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined2, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol2(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin2(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array, iteratee2) {
          var index = -1, length = array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
            if (!index || !eq(computed, seen)) {
              var seen = computed;
              result2[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result2;
        }
        function baseToNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol2(value)) {
            return NAN2;
          }
          return +value;
        }
        function baseToString(value) {
          if (typeof value == "string") {
            return value;
          }
          if (isArray(value)) {
            return arrayMap(value, baseToString) + "";
          }
          if (isSymbol2(value)) {
            return symbolToString ? symbolToString.call(value) : "";
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function baseUniq(array, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set2 = iteratee2 ? null : createSet(array);
            if (set2) {
              return setToArray(set2);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result2;
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var seenIndex = seen.length;
                while (seenIndex--) {
                  if (seen[seenIndex] === computed) {
                    continue outer;
                  }
                }
                if (iteratee2) {
                  seen.push(computed);
                }
                result2.push(value);
              } else if (!includes2(seen, computed, comparator)) {
                if (seen !== result2) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseUnset(object, path) {
          path = castPath(path, object);
          object = parent(object, path);
          return object == null || delete object[toKey(last(path))];
        }
        function baseUpdate(object, path, updater, customizer) {
          return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length, index = fromRight ? length : -1;
          while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
          }
          return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        function baseWrapperValue(value, actions) {
          var result2 = value;
          if (result2 instanceof LazyWrapper) {
            result2 = result2.value();
          }
          return arrayReduce(actions, function(result3, action) {
            return action.func.apply(action.thisArg, arrayPush([result3], action.args));
          }, result2);
        }
        function baseXor(arrays, iteratee2, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index = -1, result2 = Array2(length);
          while (++index < length) {
            var array = arrays[index], othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index) {
                result2[index] = baseDifference(result2[index] || array, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
        }
        function baseZipObject(props, values2, assignFunc) {
          var index = -1, length = props.length, valsLength = values2.length, result2 = {};
          while (++index < length) {
            var value = index < valsLength ? values2[index] : undefined2;
            assignFunc(result2, props[index], value);
          }
          return result2;
        }
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        function castFunction(value) {
          return typeof value == "function" ? value : identity;
        }
        function castPath(value, object) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object) ? [value] : stringToPath(toString(value));
        }
        var castRest = baseRest;
        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined2 ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }
        var clearTimeout2 = ctxClearTimeout || function(id) {
          return root2.clearTimeout(id);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result2);
          return result2;
        }
        function cloneArrayBuffer(arrayBuffer) {
          var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
          return result2;
        }
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        function cloneRegExp(regexp) {
          var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result2.lastIndex = regexp.lastIndex;
          return result2;
        }
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined2, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol2(value);
            var othIsDefined = other !== undefined2, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol2(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        function compareMultiple(object, other, orders) {
          var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
          while (++index < length) {
            var result2 = compareAscending(objCriteria[index], othCriteria[index]);
            if (result2) {
              if (index >= ordersLength) {
                return result2;
              }
              var order = orders[index];
              return result2 * (order == "desc" ? -1 : 1);
            }
          }
          return object.index - other.index;
        }
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result2[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result2[leftIndex++] = args[argsIndex++];
          }
          return result2;
        }
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result2[argsIndex] = args[argsIndex];
          }
          var offset = argsIndex;
          while (++rightIndex < rightLength) {
            result2[offset + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[offset + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result2;
        }
        function copyArray(source, array) {
          var index = -1, length = source.length;
          array || (array = Array2(length));
          while (++index < length) {
            array[index] = source[index];
          }
          return array;
        }
        function copyObject(source, props, object, customizer) {
          var isNew = !object;
          object || (object = {});
          var index = -1, length = props.length;
          while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined2;
            if (newValue === undefined2) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }
          return object;
        }
        function copySymbols(source, object) {
          return copyObject(source, getSymbols(source), object);
        }
        function copySymbolsIn(source, object) {
          return copyObject(source, getSymbolsIn(source), object);
        }
        function createAggregator(setter, initializer) {
          return function(collection, iteratee2) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
          };
        }
        function createAssigner(assigner) {
          return baseRest(function(object, sources) {
            var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined2, guard = length > 2 ? sources[2] : undefined2;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined2;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined2 : customizer;
              length = 1;
            }
            object = Object2(object);
            while (++index < length) {
              var source = sources[index];
              if (source) {
                assigner(object, source, index, customizer);
              }
            }
            return object;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length = collection.length, index = fromRight ? length : -1, iterable = Object2(collection);
            while (fromRight ? index-- : ++index < length) {
              if (iteratee2(iterable[index], index, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function(object, iteratee2, keysFunc) {
            var index = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object;
          };
        }
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var fn = this && this !== root2 && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper;
        }
        function createCaseFirst(methodName) {
          return function(string) {
            string = toString(string);
            var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined2;
            var chr = strSymbols ? strSymbols[0] : string.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function(string) {
            return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
          };
        }
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
            return isObject2(result2) ? result2 : thisBinding;
          };
        }
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length, placeholder = getHolder(wrapper);
            while (index--) {
              args[index] = arguments[index];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            if (length < arity) {
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                undefined2,
                args,
                holders,
                undefined2,
                undefined2,
                arity - length
              );
            }
            var fn = this && this !== root2 && this instanceof wrapper ? Ctor : func;
            return apply(fn, this, args);
          }
          return wrapper;
        }
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object2(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = function(key) {
                return iteratee2(iterable[key], key, iterable);
              };
            }
            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee2 ? collection[index] : index] : undefined2;
          };
        }
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index--) {
              var func = funcs[index];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT2);
              }
              if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index = wrapper ? index : length;
            while (++index < length) {
              func = funcs[index];
              var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined2;
              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function() {
              var args = arguments, value = args[0];
              if (wrapper && args.length == 1 && isArray(value)) {
                return wrapper.plant(value).value();
              }
              var index2 = 0, result2 = length ? funcs[index2].apply(this, args) : value;
              while (++index2 < length) {
                result2 = funcs[index2].call(this, result2);
              }
              return result2;
            };
          });
        }
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined2 : createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length;
            while (index--) {
              args[index] = arguments[index];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length -= holdersCount;
            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                thisArg,
                args,
                newHolders,
                argPos,
                ary2,
                arity - length
              );
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length) {
              args.length = ary2;
            }
            if (this && this !== root2 && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper;
        }
        function createInverter(setter, toIteratee) {
          return function(object, iteratee2) {
            return baseInverter(object, setter, toIteratee(iteratee2), {});
          };
        }
        function createMathOperation(operator, defaultValue) {
          return function(value, other) {
            var result2;
            if (value === undefined2 && other === undefined2) {
              return defaultValue;
            }
            if (value !== undefined2) {
              result2 = value;
            }
            if (other !== undefined2) {
              if (result2 === undefined2) {
                return other;
              }
              if (typeof value == "string" || typeof other == "string") {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result2 = operator(value, other);
            }
            return result2;
          };
        }
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply(iteratee2, thisArg, args);
              });
            });
          });
        }
        function createPadding(length, chars) {
          chars = chars === undefined2 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }
          var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
        }
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root2 && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn, isBind ? thisArg : this, args);
          }
          return wrapper;
        }
        function createRange(fromRight) {
          return function(start, end, step) {
            if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
              end = step = undefined2;
            }
            start = toFinite(start);
            if (end === undefined2) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined2 ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }
        function createRelationalOperation(operator) {
          return function(value, other) {
            if (!(typeof value == "string" && typeof other == "string")) {
              value = toNumber2(value);
              other = toNumber2(other);
            }
            return operator(value, other);
          };
        }
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined2, newHoldersRight = isCurry ? undefined2 : holders, newPartials = isCurry ? partials : undefined2, newPartialsRight = isCurry ? undefined2 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result2 = wrapFunc.apply(undefined2, newData);
          if (isLaziable(func)) {
            setData(result2, newData);
          }
          result2.placeholder = placeholder;
          return setWrapToString(result2, func, bitmask);
        }
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number, precision) {
            number = toNumber2(number);
            precision = precision == null ? 0 : nativeMin2(toInteger(precision), 292);
            if (precision && nativeIsFinite(number)) {
              var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString(value) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number);
          };
        }
        var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function(values2) {
          return new Set(values2);
        };
        function createToPairs(keysFunc) {
          return function(object) {
            var tag = getTag(object);
            if (tag == mapTag) {
              return mapToArray(object);
            }
            if (tag == setTag) {
              return setToPairs(object);
            }
            return baseToPairs(object, keysFunc(object));
          };
        }
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined2;
          }
          ary2 = ary2 === undefined2 ? ary2 : nativeMax2(toInteger(ary2), 0);
          arity = arity === undefined2 ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined2;
          }
          var data = isBindKey ? undefined2 : getData(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined2 ? isBindKey ? 0 : func.length : nativeMax2(newData[9] - length, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result2 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result2 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result2 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result2 = createHybrid.apply(undefined2, newData);
          }
          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result2, newData), func, bitmask);
        }
        function customDefaultsAssignIn(objValue, srcValue, key, object) {
          if (objValue === undefined2 || eq(objValue, objectProto3[key]) && !hasOwnProperty2.call(object, key)) {
            return srcValue;
          }
          return objValue;
        }
        function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
          if (isObject2(objValue) && isObject2(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined2, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        function customOmitClone(value) {
          return isPlainObject(value) ? undefined2 : value;
        }
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }
          var index = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined2;
          stack.set(array, other);
          stack.set(other, array);
          while (++index < arrLength) {
            var arrValue = array[index], othValue = other[index];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            }
            if (compared !== undefined2) {
              if (compared) {
                continue;
              }
              result2 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result2 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result2 = false;
              break;
            }
          }
          stack["delete"](array);
          stack["delete"](other);
          return result2;
        }
        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                return false;
              }
              object = object.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq(+object, +other);
            case errorTag:
              return object.name == other.name && object.message == other.message;
            case regexpTag:
            case stringTag:
              return object == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object, other);
              var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
              stack["delete"](object);
              return result2;
            case symbolTag2:
              if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index = objLength;
          while (index--) {
            var key = objProps[index];
            if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object;
          }
          var result2 = true;
          stack.set(object, other);
          stack.set(other, object);
          var skipCtor = isPartial;
          while (++index < objLength) {
            key = objProps[index];
            var objValue = object[key], othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            }
            if (!(compared === undefined2 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result2 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result2 && !skipCtor) {
            var objCtor = object.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result2 = false;
            }
          }
          stack["delete"](object);
          stack["delete"](other);
          return result2;
        }
        function flatRest(func) {
          return setToString(overRest(func, undefined2, flatten), func + "");
        }
        function getAllKeys(object) {
          return baseGetAllKeys(object, keys, getSymbols);
        }
        function getAllKeysIn(object) {
          return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        var getData = !metaMap ? noop : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty2.call(realNames, result2) ? array.length : 0;
          while (length--) {
            var data = array[length], otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result2;
        }
        function getHolder(func) {
          var object = hasOwnProperty2.call(lodash, "placeholder") ? lodash : func;
          return object.placeholder;
        }
        function getIteratee() {
          var result2 = lodash.iteratee || iteratee;
          result2 = result2 === iteratee ? baseIteratee : result2;
          return arguments.length ? result2(arguments[0], arguments[1]) : result2;
        }
        function getMapData(map2, key) {
          var data = map2.__data__;
          return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        function getMatchData(object) {
          var result2 = keys(object), length = result2.length;
          while (length--) {
            var key = result2[length], value = object[key];
            result2[length] = [key, value, isStrictComparable(value)];
          }
          return result2;
        }
        function getNative(object, key) {
          var value = getValue(object, key);
          return baseIsNative(value) ? value : undefined2;
        }
        function getRawTag2(value) {
          var isOwn = hasOwnProperty2.call(value, symToStringTag3), tag = value[symToStringTag3];
          try {
            value[symToStringTag3] = undefined2;
            var unmasked = true;
          } catch (e) {
          }
          var result2 = nativeObjectToString3.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag3] = tag;
            } else {
              delete value[symToStringTag3];
            }
          }
          return result2;
        }
        var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
          if (object == null) {
            return [];
          }
          object = Object2(object);
          return arrayFilter(nativeGetSymbols(object), function(symbol) {
            return propertyIsEnumerable.call(object, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
          var result2 = [];
          while (object) {
            arrayPush(result2, getSymbols(object));
            object = getPrototype(object);
          }
          return result2;
        };
        var getTag = baseGetTag2;
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
          getTag = function(value) {
            var result2 = baseGetTag2(value), Ctor = result2 == objectTag ? value.constructor : undefined2, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result2;
          };
        }
        function getView(start, end, transforms) {
          var index = -1, length = transforms.length;
          while (++index < length) {
            var data = transforms[index], size2 = data.size;
            switch (data.type) {
              case "drop":
                start += size2;
                break;
              case "dropRight":
                end -= size2;
                break;
              case "take":
                end = nativeMin2(end, start + size2);
                break;
              case "takeRight":
                start = nativeMax2(start, end - size2);
                break;
            }
          }
          return { "start": start, "end": end };
        }
        function getWrapDetails(source) {
          var match = source.match(reWrapDetails);
          return match ? match[1].split(reSplitDetails) : [];
        }
        function hasPath(object, path, hasFunc) {
          path = castPath(path, object);
          var index = -1, length = path.length, result2 = false;
          while (++index < length) {
            var key = toKey(path[index]);
            if (!(result2 = object != null && hasFunc(object, key))) {
              break;
            }
            object = object[key];
          }
          if (result2 || ++index != length) {
            return result2;
          }
          length = object == null ? 0 : object.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        function initCloneArray(array) {
          var length = array.length, result2 = new array.constructor(length);
          if (length && typeof array[0] == "string" && hasOwnProperty2.call(array, "index")) {
            result2.index = array.index;
            result2.input = array.input;
          }
          return result2;
        }
        function initCloneObject(object) {
          return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        function initCloneByTag(object, tag, isDeep) {
          var Ctor = object.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object);
            case boolTag:
            case dateTag:
              return new Ctor(+object);
            case dataViewTag:
              return cloneDataView(object, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object);
            case regexpTag:
              return cloneRegExp(object);
            case setTag:
              return new Ctor();
            case symbolTag2:
              return cloneSymbol(object);
          }
        }
        function insertWrapDetails(source, details) {
          var length = details.length;
          if (!length) {
            return source;
          }
          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
        }
        function isIterateeCall(value, index, object) {
          if (!isObject2(object)) {
            return false;
          }
          var type = typeof index;
          if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
            return eq(object[index], value);
          }
          return false;
        }
        function isKey(value, object) {
          if (isArray(value)) {
            return false;
          }
          var type = typeof value;
          if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol2(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
        }
        function isKeyable(value) {
          var type = typeof value;
          return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        var isMaskable = coreJsData ? isFunction : stubFalse;
        function isPrototype(value) {
          var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto3;
          return value === proto;
        }
        function isStrictComparable(value) {
          return value === value && !isObject2(value);
        }
        function matchesStrictComparable(key, srcValue) {
          return function(object) {
            if (object == null) {
              return false;
            }
            return object[key] === srcValue && (srcValue !== undefined2 || key in Object2(object));
          };
        }
        function memoizeCapped(func) {
          var result2 = memoize(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result2.cache;
          return result2;
        }
        function mergeData(data, source) {
          var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          }
          value = source[5];
          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          }
          value = source[7];
          if (value) {
            data[7] = value;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin2(data[8], source[8]);
          }
          if (data[9] == null) {
            data[9] = source[9];
          }
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        function nativeKeysIn(object) {
          var result2 = [];
          if (object != null) {
            for (var key in Object2(object)) {
              result2.push(key);
            }
          }
          return result2;
        }
        function objectToString2(value) {
          return nativeObjectToString3.call(value);
        }
        function overRest(func, start, transform2) {
          start = nativeMax2(start === undefined2 ? func.length - 1 : start, 0);
          return function() {
            var args = arguments, index = -1, length = nativeMax2(args.length - start, 0), array = Array2(length);
            while (++index < length) {
              array[index] = args[start + index];
            }
            index = -1;
            var otherArgs = Array2(start + 1);
            while (++index < start) {
              otherArgs[index] = args[index];
            }
            otherArgs[start] = transform2(array);
            return apply(func, this, otherArgs);
          };
        }
        function parent(object, path) {
          return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        function reorder(array, indexes) {
          var arrLength = array.length, length = nativeMin2(indexes.length, arrLength), oldArray = copyArray(array);
          while (length--) {
            var index = indexes[length];
            array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined2;
          }
          return array;
        }
        function safeGet(object, key) {
          if (key === "constructor" && typeof object[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object[key];
        }
        var setData = shortOut(baseSetData);
        var setTimeout2 = ctxSetTimeout || function(func, wait) {
          return root2.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + "";
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        function shortOut(func) {
          var count = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined2, arguments);
          };
        }
        function shuffleSelf(array, size2) {
          var index = -1, length = array.length, lastIndex = length - 1;
          size2 = size2 === undefined2 ? length : size2;
          while (++index < size2) {
            var rand = baseRandom(index, lastIndex), value = array[rand];
            array[rand] = array[index];
            array[index] = value;
          }
          array.length = size2;
          return array;
        }
        var stringToPath = memoizeCapped(function(string) {
          var result2 = [];
          if (string.charCodeAt(0) === 46) {
            result2.push("");
          }
          string.replace(rePropName, function(match, number, quote, subString) {
            result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
          });
          return result2;
        });
        function toKey(value) {
          if (typeof value == "string" || isSymbol2(value)) {
            return value;
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {
            }
            try {
              return func + "";
            } catch (e) {
            }
          }
          return "";
        }
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result2.__actions__ = copyArray(wrapper.__actions__);
          result2.__index__ = wrapper.__index__;
          result2.__values__ = wrapper.__values__;
          return result2;
        }
        function chunk(array, size2, guard) {
          if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined2) {
            size2 = 1;
          } else {
            size2 = nativeMax2(toInteger(size2), 0);
          }
          var length = array == null ? 0 : array.length;
          if (!length || size2 < 1) {
            return [];
          }
          var index = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size2));
          while (index < length) {
            result2[resIndex++] = baseSlice(array, index, index += size2);
          }
          return result2;
        }
        function compact(array) {
          var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index];
            if (value) {
              result2[resIndex++] = value;
            }
          }
          return result2;
        }
        function concat() {
          var length = arguments.length;
          if (!length) {
            return [];
          }
          var args = Array2(length - 1), array = arguments[0], index = length;
          while (index--) {
            args[index - 1] = arguments[index];
          }
          return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
        }
        var difference = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array, values2) {
          var iteratee2 = last(values2);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array, values2) {
          var comparator = last(values2);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined2, comparator) : [];
        });
        function drop(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function dropRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        function fill(array, value, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array, value, start, end);
        }
        function findIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax2(length + index, 0);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        function findLastIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length - 1;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = fromIndex < 0 ? nativeMax2(length + index, 0) : nativeMin2(index, length - 1);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        function flatten(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, 1) : [];
        }
        function flattenDeep(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, INFINITY) : [];
        }
        function flattenDepth(array, depth) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(array, depth);
        }
        function fromPairs(pairs) {
          var index = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
          while (++index < length) {
            var pair = pairs[index];
            result2[pair[0]] = pair[1];
          }
          return result2;
        }
        function head(array) {
          return array && array.length ? array[0] : undefined2;
        }
        function indexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax2(length + index, 0);
          }
          return baseIndexOf(array, value, index);
        }
        function initial(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 0, -1) : [];
        }
        var intersection = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined2;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined2, comparator) : [];
        });
        function join(array, separator) {
          return array == null ? "" : nativeJoin.call(array, separator);
        }
        function last(array) {
          var length = array == null ? 0 : array.length;
          return length ? array[length - 1] : undefined2;
        }
        function lastIndexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = index < 0 ? nativeMax2(length + index, 0) : nativeMin2(index, length - 1);
          }
          return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        function nth(array, n) {
          return array && array.length ? baseNth(array, toInteger(n)) : undefined2;
        }
        var pull = baseRest(pullAll);
        function pullAll(array, values2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
        }
        function pullAllBy(array, values2, iteratee2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
        }
        function pullAllWith(array, values2, comparator) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined2, comparator) : array;
        }
        var pullAt = flatRest(function(array, indexes) {
          var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function(index) {
            return isIndex(index, length) ? +index : index;
          }).sort(compareAscending));
          return result2;
        });
        function remove(array, predicate) {
          var result2 = [];
          if (!(array && array.length)) {
            return result2;
          }
          var index = -1, indexes = [], length = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index < length) {
            var value = array[index];
            if (predicate(value, index, array)) {
              result2.push(value);
              indexes.push(index);
            }
          }
          basePullAt(array, indexes);
          return result2;
        }
        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }
        function slice(array, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined2 ? length : toInteger(end);
          }
          return baseSlice(array, start, end);
        }
        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }
        function sortedIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
        }
        function sortedIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value);
            if (index < length && eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }
        function sortedLastIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
        }
        function sortedLastIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value, true) - 1;
            if (eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        function sortedUniqBy(array, iteratee2) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function tail(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 1, length) : [];
        }
        function take(array, n, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function takeRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined2, comparator);
        });
        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        function uniqBy(array, iteratee2) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function uniqWith(array, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return array && array.length ? baseUniq(array, undefined2, comparator) : [];
        }
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length = 0;
          array = arrayFilter(array, function(group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax2(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function(index) {
            return arrayMap(array, baseProperty(index));
          });
        }
        function unzipWith(array, iteratee2) {
          if (!(array && array.length)) {
            return [];
          }
          var result2 = unzip(array);
          if (iteratee2 == null) {
            return result2;
          }
          return arrayMap(result2, function(group) {
            return apply(iteratee2, undefined2, group);
          });
        }
        var without = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined2, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values2) {
          return baseZipObject(props || [], values2 || [], assignValue);
        }
        function zipObjectDeep(props, values2) {
          return baseZipObject(props || [], values2 || [], baseSet);
        }
        var zipWith = baseRest(function(arrays) {
          var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined2;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined2;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value) {
          var result2 = lodash(value);
          result2.__chain__ = true;
          return result2;
        }
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        function thru(value, interceptor) {
          return interceptor(value);
        }
        var wrapperAt = flatRest(function(paths) {
          var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
            return baseAt(object, paths);
          };
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            "func": thru,
            "args": [interceptor],
            "thisArg": undefined2
          });
          return new LodashWrapper(value, this.__chain__).thru(function(array) {
            if (length && !array.length) {
              array.push(undefined2);
            }
            return array;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperNext() {
          if (this.__values__ === undefined2) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value = done ? undefined2 : this.__values__[this.__index__++];
          return { "done": done, "value": value };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value) {
          var result2, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone2 = wrapperClone(parent2);
            clone2.__index__ = 0;
            clone2.__values__ = undefined2;
            if (result2) {
              previous.__wrapped__ = clone2;
            } else {
              result2 = clone2;
            }
            var previous = clone2;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result2;
        }
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [reverse],
              "thisArg": undefined2
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty2.call(result2, key)) {
            ++result2[key];
          } else {
            baseAssignValue(result2, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        var find = createFind(findIndex);
        var findLast = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), 1);
        }
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), INFINITY);
        }
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(map(collection, iteratee2), depth);
        }
        function forEach(collection, iteratee2) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function forEachRight(collection, iteratee2) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        var groupBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty2.call(result2, key)) {
            result2[key].push(value);
          } else {
            baseAssignValue(result2, key, [value]);
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax2(length + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        var invokeMap = baseRest(function(collection, path, args) {
          var index = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value) {
            result2[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
          });
          return result2;
        });
        var keyBy = createAggregator(function(result2, value, key) {
          baseAssignValue(result2, key, value);
        });
        function map(collection, iteratee2) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined2 : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition = createAggregator(function(result2, value, key) {
          result2[key ? 0 : 1].push(value);
        }, function() {
          return [[], []];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }
        function sampleSize(collection, n, guard) {
          if (guard ? isIterateeCall(collection, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n);
        }
        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        function size(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now2 = ctxNow || function() {
          return root2.Date.now();
        };
        function after(n, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          n = toInteger(n);
          return function() {
            if (--n < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n, guard) {
          n = guard ? undefined2 : n;
          n = func && n == null ? func.length : n;
          return createWrap(func, WRAP_ARY_FLAG, undefined2, undefined2, undefined2, undefined2, n);
        }
        function before(n, func) {
          var result2;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          n = toInteger(n);
          return function() {
            if (--n > 0) {
              result2 = func.apply(this, arguments);
            }
            if (n <= 1) {
              func = undefined2;
            }
            return result2;
          };
        }
        var bind = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curry.placeholder;
          return result2;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curryRight.placeholder;
          return result2;
        }
        function debounce2(func, wait, options) {
          var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          wait = toNumber2(wait) || 0;
          if (isObject2(options)) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing ? nativeMax2(toNumber2(options.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined2;
            lastInvokeTime = time;
            result2 = func.apply(thisArg, args);
            return result2;
          }
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout2(timerExpired, wait);
            return leading ? invokeFunc(time) : result2;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin2(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined2 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now2();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout2(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined2;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined2;
            return result2;
          }
          function cancel() {
            if (timerId !== undefined2) {
              clearTimeout2(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined2;
          }
          function flush() {
            return timerId === undefined2 ? result2 : trailingEdge(now2());
          }
          function debounced() {
            var time = now2(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined2) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout2(timerId);
                timerId = setTimeout2(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined2) {
              timerId = setTimeout2(timerExpired, wait);
            }
            return result2;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber2(wait) || 0, args);
        });
        function flip(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        function memoize(func, resolver) {
          if (typeof func != "function" || resolver != null && typeof resolver != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result2 = func.apply(this, args);
            memoized.cache = cache.set(key, result2) || cache;
            return result2;
          };
          memoized.cache = new (memoize.Cache || MapCache)();
          return memoized;
        }
        memoize.Cache = MapCache;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        function once(func) {
          return before(2, func);
        }
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index = -1, length = nativeMin2(args.length, funcsLength);
            while (++index < length) {
              args[index] = transforms[index].call(this, args[index]);
            }
            return apply(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined2, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined2, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined2, undefined2, undefined2, indexes);
        });
        function rest(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          start = start === undefined2 ? start : toInteger(start);
          return baseRest(func, start);
        }
        function spread(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          start = start == null ? 0 : nativeMax2(toInteger(start), 0);
          return baseRest(function(args) {
            var array = args[start], otherArgs = castSlice(args, 0, start);
            if (array) {
              arrayPush(otherArgs, array);
            }
            return apply(func, this, otherArgs);
          });
        }
        function throttle(func, wait, options) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          if (isObject2(options)) {
            leading = "leading" in options ? !!options.leading : leading;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          return debounce2(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray(value) ? value : [value];
        }
        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        function cloneWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        function cloneDeep(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        function conformsTo(object, source) {
          return source == null || baseConformsTo(object, source, keys(source));
        }
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        var gt = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value, other) {
          return value >= other;
        });
        var isArguments = baseIsArguments(function() {
          return arguments;
        }()) ? baseIsArguments : function(value) {
          return isObjectLike2(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        var isArray = Array2.isArray;
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        function isArrayLikeObject(value) {
          return isObjectLike2(value) && isArrayLike(value);
        }
        function isBoolean(value) {
          return value === true || value === false || isObjectLike2(value) && baseGetTag2(value) == boolTag;
        }
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement(value) {
          return isObjectLike2(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        function isEmpty(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty2.call(value, key)) {
              return false;
            }
          }
          return true;
        }
        function isEqual(value, other) {
          return baseIsEqual(value, other);
        }
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          var result2 = customizer ? customizer(value, other) : undefined2;
          return result2 === undefined2 ? baseIsEqual(value, other, undefined2, customizer) : !!result2;
        }
        function isError(value) {
          if (!isObjectLike2(value)) {
            return false;
          }
          var tag = baseGetTag2(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        function isFinite(value) {
          return typeof value == "number" && nativeIsFinite(value);
        }
        function isFunction(value) {
          if (!isObject2(value)) {
            return false;
          }
          var tag = baseGetTag2(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        function isInteger(value) {
          return typeof value == "number" && value == toInteger(value);
        }
        function isLength(value) {
          return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        function isObject2(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }
        function isObjectLike2(value) {
          return value != null && typeof value == "object";
        }
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch(object, source) {
          return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        function isMatchWith(object, source, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        function isNaN(value) {
          return isNumber(value) && value != +value;
        }
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error2(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }
        function isNull(value) {
          return value === null;
        }
        function isNil(value) {
          return value == null;
        }
        function isNumber(value) {
          return typeof value == "number" || isObjectLike2(value) && baseGetTag2(value) == numberTag;
        }
        function isPlainObject(value) {
          if (!isObjectLike2(value) || baseGetTag2(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty2.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value) {
          return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString(value) {
          return typeof value == "string" || !isArray(value) && isObjectLike2(value) && baseGetTag2(value) == stringTag;
        }
        function isSymbol2(value) {
          return typeof value == "symbol" || isObjectLike2(value) && baseGetTag2(value) == symbolTag2;
        }
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined(value) {
          return value === undefined2;
        }
        function isWeakMap(value) {
          return isObjectLike2(value) && getTag(value) == weakMapTag;
        }
        function isWeakSet(value) {
          return isObjectLike2(value) && baseGetTag2(value) == weakSetTag;
        }
        var lt = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value, other) {
          return value <= other;
        });
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber2(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }
        function toInteger(value) {
          var result2 = toFinite(value), remainder = result2 % 1;
          return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
        }
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber2(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol2(value)) {
            return NAN2;
          }
          if (isObject2(value)) {
            var other = typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject2(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim2(value);
          var isBinary = reIsBinary2.test(value);
          return isBinary || reIsOctal2.test(value) ? freeParseInt2(value.slice(2), isBinary ? 2 : 8) : reIsBadHex2.test(value) ? NAN2 : +value;
        }
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        function toString(value) {
          return value == null ? "" : baseToString(value);
        }
        var assign = createAssigner(function(object, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty2.call(source, key)) {
              assignValue(object, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object, source) {
          copyObject(source, keysIn(source), object);
        });
        var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object, customizer);
        });
        var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keys(source), object, customizer);
        });
        var at = flatRest(baseAt);
        function create(prototype, properties) {
          var result2 = baseCreate(prototype);
          return properties == null ? result2 : baseAssign(result2, properties);
        }
        var defaults = baseRest(function(object, sources) {
          object = Object2(object);
          var index = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined2;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }
          while (++index < length) {
            var source = sources[index];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object[key];
              if (value === undefined2 || eq(value, objectProto3[key]) && !hasOwnProperty2.call(object, key)) {
                object[key] = source[key];
              }
            }
          }
          return object;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined2, customDefaultsMerge);
          return apply(mergeWith, undefined2, args);
        });
        function findKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        function findLastKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        function forIn(object, iteratee2) {
          return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forInRight(object, iteratee2) {
          return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forOwn(object, iteratee2) {
          return object && baseForOwn(object, getIteratee(iteratee2, 3));
        }
        function forOwnRight(object, iteratee2) {
          return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
        }
        function functions(object) {
          return object == null ? [] : baseFunctions(object, keys(object));
        }
        function functionsIn(object) {
          return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        function get(object, path, defaultValue) {
          var result2 = object == null ? undefined2 : baseGet(object, path);
          return result2 === undefined2 ? defaultValue : result2;
        }
        function has(object, path) {
          return object != null && hasPath(object, path, baseHas);
        }
        function hasIn(object, path) {
          return object != null && hasPath(object, path, baseHasIn);
        }
        var invert = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString3.call(value);
          }
          result2[value] = key;
        }, constant(identity));
        var invertBy = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString3.call(value);
          }
          if (hasOwnProperty2.call(result2, value)) {
            result2[value].push(key);
          } else {
            result2[value] = [key];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        function keysIn(object) {
          return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        function mapKeys(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, iteratee2(value, key, object2), value);
          });
          return result2;
        }
        function mapValues(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, key, iteratee2(value, key, object2));
          });
          return result2;
        }
        var merge = createAssigner(function(object, source, srcIndex) {
          baseMerge(object, source, srcIndex);
        });
        var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
          baseMerge(object, source, srcIndex, customizer);
        });
        var omit = flatRest(function(object, paths) {
          var result2 = {};
          if (object == null) {
            return result2;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path) {
            path = castPath(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object, getAllKeysIn(object), result2);
          if (isDeep) {
            result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length = paths.length;
          while (length--) {
            baseUnset(result2, paths[length]);
          }
          return result2;
        });
        function omitBy(object, predicate) {
          return pickBy(object, negate(getIteratee(predicate)));
        }
        var pick = flatRest(function(object, paths) {
          return object == null ? {} : basePick(object, paths);
        });
        function pickBy(object, predicate) {
          if (object == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object), function(prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object, props, function(value, path) {
            return predicate(value, path[0]);
          });
        }
        function result(object, path, defaultValue) {
          path = castPath(path, object);
          var index = -1, length = path.length;
          if (!length) {
            length = 1;
            object = undefined2;
          }
          while (++index < length) {
            var value = object == null ? undefined2 : object[toKey(path[index])];
            if (value === undefined2) {
              index = length;
              value = defaultValue;
            }
            object = isFunction(value) ? value.call(object) : value;
          }
          return object;
        }
        function set(object, path, value) {
          return object == null ? object : baseSet(object, path, value);
        }
        function setWith(object, path, value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseSet(object, path, value, customizer);
        }
        var toPairs = createToPairs(keys);
        var toPairsIn = createToPairs(keysIn);
        function transform(object, iteratee2, accumulator) {
          var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object && object.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject2(object)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object2) {
            return iteratee2(accumulator, value, index, object2);
          });
          return accumulator;
        }
        function unset(object, path) {
          return object == null ? true : baseUnset(object, path);
        }
        function update(object, path, updater) {
          return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        function updateWith(object, path, updater, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        function values(object) {
          return object == null ? [] : baseValues(object, keys(object));
        }
        function valuesIn(object) {
          return object == null ? [] : baseValues(object, keysIn(object));
        }
        function clamp(number, lower, upper) {
          if (upper === undefined2) {
            upper = lower;
            lower = undefined2;
          }
          if (upper !== undefined2) {
            upper = toNumber2(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined2) {
            lower = toNumber2(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber2(number), lower, upper);
        }
        function inRange(number, start, end) {
          start = toFinite(start);
          if (end === undefined2) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          number = toNumber2(number);
          return baseInRange(number, start, end);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined2;
          }
          if (floating === undefined2) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined2;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined2;
            }
          }
          if (lower === undefined2 && upper === undefined2) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined2) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin2(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase = createCompounder(function(result2, word, index) {
          word = word.toLowerCase();
          return result2 + (index ? capitalize(word) : word);
        });
        function capitalize(string) {
          return upperFirst(toString(string).toLowerCase());
        }
        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        function endsWith(string, target, position) {
          string = toString(string);
          target = baseToString(target);
          var length = string.length;
          position = position === undefined2 ? length : baseClamp(toInteger(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string.slice(position, end) == target;
        }
        function escape(string) {
          string = toString(string);
          return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        var kebabCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          if (!length || strLength >= length) {
            return string;
          }
          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        function padEnd(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        function padStart(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        function parseInt2(string, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string).replace(reTrimStart2, ""), radix || 0);
        }
        function repeat(string, n, guard) {
          if (guard ? isIterateeCall(string, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          return baseRepeat(toString(string), n);
        }
        function replace() {
          var args = arguments, string = toString(args[0]);
          return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? "_" : "") + word.toLowerCase();
        });
        function split(string, separator, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
            separator = limit = undefined2;
          }
          limit = limit === undefined2 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string = toString(string);
          if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);
            if (!separator && hasUnicode(string)) {
              return castSlice(stringToArray(string), 0, limit);
            }
          }
          return string.split(separator, limit);
        }
        var startCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + upperFirst(word);
        });
        function startsWith(string, target, position) {
          string = toString(string);
          position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
          target = baseToString(target);
          return string.slice(position, position + target.length) == target;
        }
        function template(string, options, guard) {
          var settings = lodash.templateSettings;
          if (guard && isIterateeCall(string, options, guard)) {
            options = undefined2;
          }
          string = toString(string);
          options = assignInWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
          var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp2(
            (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
            "g"
          );
          var sourceURL = "//# sourceURL=" + (hasOwnProperty2.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index = offset + match.length;
            return match;
          });
          source += "';\n";
          var variable = hasOwnProperty2.call(options, "variable") && options.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result2 = attempt(function() {
            return Function2(importsKeys, sourceURL + "return " + source).apply(undefined2, importsValues);
          });
          result2.source = source;
          if (isError(result2)) {
            throw result2;
          }
          return result2;
        }
        function toLower(value) {
          return toString(value).toLowerCase();
        }
        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        function trim(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return baseTrim2(string);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join("");
        }
        function trimEnd(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.slice(0, trimmedEndIndex2(string) + 1);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join("");
        }
        function trimStart(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.replace(reTrimStart2, "");
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join("");
        }
        function truncate(string, options) {
          var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject2(options)) {
            var separator = "separator" in options ? options.separator : separator;
            length = "length" in options ? toInteger(options.length) : length;
            omission = "omission" in options ? baseToString(options.omission) : omission;
          }
          string = toString(string);
          var strLength = string.length;
          if (hasUnicode(string)) {
            var strSymbols = stringToArray(string);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
          if (separator === undefined2) {
            return result2 + omission;
          }
          if (strSymbols) {
            end += result2.length - end;
          }
          if (isRegExp(separator)) {
            if (string.slice(end).search(separator)) {
              var match, substring = result2;
              if (!separator.global) {
                separator = RegExp2(separator.source, toString(reFlags.exec(separator)) + "g");
              }
              separator.lastIndex = 0;
              while (match = separator.exec(substring)) {
                var newEnd = match.index;
              }
              result2 = result2.slice(0, newEnd === undefined2 ? end : newEnd);
            }
          } else if (string.indexOf(baseToString(separator), end) != end) {
            var index = result2.lastIndexOf(separator);
            if (index > -1) {
              result2 = result2.slice(0, index);
            }
          }
          return result2 + omission;
        }
        function unescape(string) {
          string = toString(string);
          return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        var upperCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined2 : pattern;
          if (pattern === undefined2) {
            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
          }
          return string.match(pattern) || [];
        }
        var attempt = baseRest(function(func, args) {
          try {
            return apply(func, undefined2, args);
          } catch (e) {
            return isError(e) ? e : new Error2(e);
          }
        });
        var bindAll = flatRest(function(object, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey(key);
            baseAssignValue(object, key, bind(object[key], object));
          });
          return object;
        });
        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT2);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function(args) {
            var index = -1;
            while (++index < length) {
              var pair = pairs[index];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        function constant(value) {
          return function() {
            return value;
          };
        }
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity(value) {
          return value;
        }
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        var method = baseRest(function(path, args) {
          return function(object) {
            return baseInvoke(object, path, args);
          };
        });
        var methodOf = baseRest(function(object, args) {
          return function(path) {
            return baseInvoke(object, path, args);
          };
        });
        function mixin(object, source, options) {
          var props = keys(source), methodNames = baseFunctions(source, props);
          if (options == null && !(isObject2(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object;
            object = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain2 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object[methodName] = func;
            if (isFunc) {
              object.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                  actions.push({ "func": func, "args": arguments, "thisArg": object });
                  result2.__chain__ = chainAll;
                  return result2;
                }
                return func.apply(object, arrayPush([this.value()], arguments));
              };
            }
          });
          return object;
        }
        function noConflict() {
          if (root2._ === this) {
            root2._ = oldDash;
          }
          return this;
        }
        function noop() {
        }
        function nthArg(n) {
          n = toInteger(n);
          return baseRest(function(args) {
            return baseNth(args, n);
          });
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        function propertyOf(object) {
          return function(path) {
            return object == null ? undefined2 : baseGet(object, path);
          };
        }
        var range = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        function stubFalse() {
          return false;
        }
        function stubObject() {
          return {};
        }
        function stubString() {
          return "";
        }
        function stubTrue() {
          return true;
        }
        function times(n, iteratee2) {
          n = toInteger(n);
          if (n < 1 || n > MAX_SAFE_INTEGER) {
            return [];
          }
          var index = MAX_ARRAY_LENGTH, length = nativeMin2(n, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n -= MAX_ARRAY_LENGTH;
          var result2 = baseTimes(length, iteratee2);
          while (++index < n) {
            iteratee2(index);
          }
          return result2;
        }
        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol2(value) ? [value] : copyArray(stringToPath(toString(value)));
        }
        function uniqueId(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }
        var add = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor = createRound("floor");
        function max(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined2;
        }
        function maxBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined2;
        }
        function mean(array) {
          return baseMean(array, identity);
        }
        function meanBy(array, iteratee2) {
          return baseMean(array, getIteratee(iteratee2, 2));
        }
        function min(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined2;
        }
        function minBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined2;
        }
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round = createRound("round");
        var subtract = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }
        function sumBy(array, iteratee2) {
          return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
        }
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce2;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        mixin(lodash, lodash);
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject2;
        lodash.isObjectLike = isObjectLike2;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol2;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now2;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt2;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext2;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber2;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
          var source = {};
          baseForOwn(lodash, function(func, methodName) {
            if (!hasOwnProperty2.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), { "chain": false });
        lodash.VERSION = VERSION;
        arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
          lodash[methodName].placeholder = lodash;
        });
        arrayEach(["drop", "take"], function(methodName, index) {
          LazyWrapper.prototype[methodName] = function(n) {
            n = n === undefined2 ? 1 : nativeMax2(toInteger(n), 0);
            var result2 = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
            if (result2.__filtered__) {
              result2.__takeCount__ = nativeMin2(n, result2.__takeCount__);
            } else {
              result2.__views__.push({
                "size": nativeMin2(n, MAX_ARRAY_LENGTH),
                "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
              });
            }
            return result2;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n) {
            return this.reverse()[methodName](n).reverse();
          };
        });
        arrayEach(["filter", "map", "takeWhile"], function(methodName, index) {
          var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result2 = this.clone();
            result2.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type
            });
            result2.__filtered__ = result2.__filtered__ || isFilter;
            return result2;
          };
        });
        arrayEach(["head", "last"], function(methodName, index) {
          var takeName = "take" + (index ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach(["initial", "tail"], function(methodName, index) {
          var dropName = "drop" + (index ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
          if (typeof path == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
          start = toInteger(start);
          var result2 = this;
          if (result2.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result2);
          }
          if (start < 0) {
            result2 = result2.takeRight(-start);
          } else if (start) {
            result2 = result2.drop(start);
          }
          if (end !== undefined2) {
            end = toInteger(end);
            result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
          }
          return result2;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash.prototype[methodName] = function() {
            var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value);
            var interceptor = function(value2) {
              var result3 = lodashFunc.apply(lodash, arrayPush([value2], args));
              return isTaker && chainAll ? result3[0] : result3;
            };
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result2 = func.apply(value, args);
              result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined2 });
              return new LodashWrapper(result2, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result2 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
          };
        });
        arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }
            return this[chainName](function(value2) {
              return func.apply(isArray(value2) ? value2 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty2.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({ "name": methodName, "func": lodashFunc });
          }
        });
        realNames[createHybrid(undefined2, WRAP_BIND_KEY_FLAG).name] = [{
          "name": "wrapper",
          "func": undefined2
        }];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) {
          lodash.prototype[symIterator] = wrapperToIterator;
        }
        return lodash;
      };
      var _2 = runInContext();
      if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        root2._ = _2;
        define(function() {
          return _2;
        });
      } else if (freeModule) {
        (freeModule.exports = _2)._ = _2;
        freeExports._ = _2;
      } else {
        root2._ = _2;
      }
    }).call(exports);
  }
});

// src/email-templates/components/__generated__/EmailNotificationsList_notifications.graphql.ts
var node = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dateFrom"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dateTo"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "emailProvider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "notificationType"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "pageNumber"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "pageSize"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "toEmail"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmailNotificationsList_notifications",
  "selections": [
    {
      "alias": "notifications",
      "args": [
        {
          "kind": "Variable",
          "name": "dateFrom",
          "variableName": "dateFrom"
        },
        {
          "kind": "Variable",
          "name": "dateTo",
          "variableName": "dateTo"
        },
        {
          "kind": "Variable",
          "name": "emailProvider",
          "variableName": "emailProvider"
        },
        {
          "kind": "Variable",
          "name": "notificationType",
          "variableName": "notificationType"
        },
        {
          "kind": "Variable",
          "name": "pageNumber",
          "variableName": "pageNumber"
        },
        {
          "kind": "Variable",
          "name": "pageSize",
          "variableName": "pageSize"
        },
        {
          "kind": "Variable",
          "name": "toEmail",
          "variableName": "toEmail"
        }
      ],
      "concreteType": "NotificationsEmailNotificationSummaries",
      "kind": "LinkedField",
      "name": "notificationsEmailNotificationSummaries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalItems",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NotificationsEmailNotificationSummary",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailNotificationSummaryId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmailNotificationRow_notification"
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
node.hash = "5432b5352c07112c76f5efc5b6b7d9b8";
var EmailNotificationsList_notifications_graphql_default = node;

// src/email-templates/components/EmailNotificationsList.tsx
import { Suspense } from "react";
import { useFragment as useFragment2 } from "react-relay";
import { isNotNullOrUndefined } from "shared-lib";
import { EdSkeleton, EdTable, SimplePagination } from "shared-ui";

// src/email-templates/components/__generated__/EmailNotificationRow_notification.graphql.ts
var node2 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmailNotificationRow_notification",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailNotificationSummaryId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toEmail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notificationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAttempts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "providerTypes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wasSent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wasDelivered",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wasOpened",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wasClicked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wasHardBounced",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wasSoftBounced",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wasMarkedAsSpam",
      "storageKey": null
    }
  ],
  "type": "NotificationsEmailNotificationSummary",
  "abstractKey": null
};
node2.hash = "b87904717a20b134b09dda9a72c87a94";
var EmailNotificationRow_notification_graphql_default = node2;

// src/email-templates/components/EmailNotificationRow.tsx
import { useCallback } from "react";
import { useFragment } from "react-relay";
import { BooleanIcon, EdColumnCell, EdRow } from "shared-ui";
import { timeAgo } from "shared-lib";
import { jsx, jsxs } from "react/jsx-runtime";
var fragmentDef = EmailNotificationRow_notification_graphql_default;
var emailNotificationRowColumns = [
  { id: "createdAt", name: "Created" },
  { id: "toName", name: "To" },
  { id: "notificationType", name: "Notification" },
  { id: "wasSent", name: "Sent" },
  { id: "wasDelivered", name: "Delivered" },
  { id: "wasOpened", name: "Opened" },
  { id: "wasClicked", name: "Clicked" },
  { id: "wasMarkedAsSpam", name: "Marked As Spam" },
  { id: "wasBounced", name: "Bounced" }
];
var EmailNotificationRow = ({
  fragmentRef,
  onSelect
}) => {
  const data = useFragment(fragmentDef, fragmentRef);
  const select = useCallback(() => {
    onSelect(data);
  }, [data, onSelect]);
  return /* @__PURE__ */ jsxs(
    EdRow,
    {
      bordered: true,
      clicked: select,
      rowKey: data.emailNotificationSummaryId,
      children: [
        /* @__PURE__ */ jsx(EdColumnCell, { children: /* @__PURE__ */ jsx("div", { className: "text-sm text-gray-700", children: timeAgo(data.createdAt) }) }),
        /* @__PURE__ */ jsx(EdColumnCell, { children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-2 text-sm", children: [
          /* @__PURE__ */ jsx("div", { children: data.toName }),
          /* @__PURE__ */ jsx("div", { children: data.toEmail })
        ] }) }),
        /* @__PURE__ */ jsx(EdColumnCell, { children: /* @__PURE__ */ jsx("div", { className: "text-primary-500 text-sm", children: data.notificationType }) }),
        /* @__PURE__ */ jsx(EdColumnCell, { children: /* @__PURE__ */ jsx(BooleanIcon, { value: data.wasSent }) }),
        /* @__PURE__ */ jsx(EdColumnCell, { children: /* @__PURE__ */ jsx(BooleanIcon, { value: data.wasDelivered }) }),
        /* @__PURE__ */ jsx(EdColumnCell, { children: /* @__PURE__ */ jsx(BooleanIcon, { value: data.wasOpened }) }),
        /* @__PURE__ */ jsx(EdColumnCell, { children: /* @__PURE__ */ jsx(BooleanIcon, { value: data.wasClicked }) }),
        /* @__PURE__ */ jsx(EdColumnCell, { children: /* @__PURE__ */ jsx(BooleanIcon, { value: data.wasMarkedAsSpam }) }),
        /* @__PURE__ */ jsx(EdColumnCell, { children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-2", children: [
          data.wasSoftBounced && /* @__PURE__ */ jsx("div", { className: "text-danger-500 text-sm", children: /* @__PURE__ */ jsx("div", { children: "Soft" }) }),
          data.wasHardBounced && /* @__PURE__ */ jsx("div", { className: "text-danger-500 text-sm", children: /* @__PURE__ */ jsx("div", { children: "Hard" }) })
        ] }) })
      ]
    }
  );
};

// src/email-templates/components/EmailNotificationsList.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var fragmentDef2 = EmailNotificationsList_notifications_graphql_default;
var EmailNotificationItem = ({
  item,
  onSelect
}) => {
  return /* @__PURE__ */ jsx2(
    EmailNotificationRow,
    {
      fragmentRef: item,
      onSelect
    },
    item.emailNotificationSummaryId
  );
};
var EmailNotificationsList = ({
  fragmentRef,
  onPage,
  onSelect
}) => {
  const data = useFragment2(
    fragmentDef2,
    fragmentRef
  );
  const { notifications } = data;
  const rows = (notifications.items || []).filter(isNotNullOrUndefined).map((e) => {
    return /* @__PURE__ */ jsx2(
      EmailNotificationItem,
      {
        item: e,
        onSelect
      },
      e.emailNotificationSummaryId
    );
  });
  return /* @__PURE__ */ jsxs2("div", { className: "flex h-screen w-full flex-col", children: [
    /* @__PURE__ */ jsx2("div", { className: "flex p-2", children: /* @__PURE__ */ jsx2(
      SimplePagination,
      {
        name: "pg",
        totalResults: notifications.totalItems,
        itemsPerPage: notifications.pageSize,
        pageNumber: notifications.pageNumber,
        pages: notifications.pages,
        onPage
      }
    ) }),
    /* @__PURE__ */ jsx2("div", { className: "flex-1", children: /* @__PURE__ */ jsx2(Suspense, { fallback: /* @__PURE__ */ jsx2(EdSkeleton, {}), children: /* @__PURE__ */ jsx2(
      EdTable,
      {
        fixedHeight: false,
        classes: "h-full",
        defaultColumns: emailNotificationRowColumns,
        rows
      }
    ) }) })
  ] });
};

// src/email-templates/components/__generated__/EmailNotificationsListContainerQuery.graphql.ts
var node3 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dateFrom"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dateTo"
  }, v2 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "emailProvider"
  }, v3 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "notificationType"
  }, v4 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageNumber"
  }, v5 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "toEmail"
  }, v6 = {
    "kind": "Variable",
    "name": "dateFrom",
    "variableName": "dateFrom"
  }, v7 = {
    "kind": "Variable",
    "name": "dateTo",
    "variableName": "dateTo"
  }, v8 = {
    "kind": "Variable",
    "name": "emailProvider",
    "variableName": "emailProvider"
  }, v9 = {
    "kind": "Variable",
    "name": "notificationType",
    "variableName": "notificationType"
  }, v10 = {
    "kind": "Variable",
    "name": "pageNumber",
    "variableName": "pageNumber"
  }, v11 = {
    "kind": "Variable",
    "name": "toEmail",
    "variableName": "toEmail"
  }, v12 = {
    "alias": "providers",
    "args": null,
    "kind": "ScalarField",
    "name": "notificationsEmailProviders",
    "storageKey": null
  }, v13 = {
    "alias": "notificationTypes",
    "args": null,
    "concreteType": "EmailNotificationTypes",
    "kind": "LinkedField",
    "name": "notificationsEmailNotificationTypes",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      }
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v2,
        v3,
        v4,
        v5
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailNotificationsListContainerQuery",
      "selections": [
        {
          "args": [
            v6,
            v7,
            v8,
            v9,
            v10,
            v11
          ],
          "kind": "FragmentSpread",
          "name": "EmailNotificationsList_notifications"
        },
        v12,
        v13
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v5,
        v3,
        v2,
        v0,
        v1,
        v4
      ],
      "kind": "Operation",
      "name": "EmailNotificationsListContainerQuery",
      "selections": [
        {
          "alias": "notifications",
          "args": [
            v6,
            v7,
            v8,
            v9,
            v10,
            {
              "kind": "Literal",
              "name": "pageSize",
              "value": 10
            },
            v11
          ],
          "concreteType": "NotificationsEmailNotificationSummaries",
          "kind": "LinkedField",
          "name": "notificationsEmailNotificationSummaries",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pageNumber",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pages",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pageSize",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalItems",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationsEmailNotificationSummary",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailNotificationSummaryId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "toEmail",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "toName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "notificationType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailAttempts",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "providerTypes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "wasSent",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "wasDelivered",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "wasOpened",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "wasClicked",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "wasHardBounced",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "wasSoftBounced",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "wasMarkedAsSpam",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        v12,
        v13
      ]
    },
    "params": {
      "cacheID": "183cb7faaee32c5b54adac6c39b4eac2",
      "id": null,
      "metadata": {},
      "name": "EmailNotificationsListContainerQuery",
      "operationKind": "query",
      "text": "query EmailNotificationsListContainerQuery(\n  $toEmail: String\n  $notificationType: String\n  $emailProvider: String\n  $dateFrom: DateTime\n  $dateTo: DateTime\n  $pageNumber: Int!\n) {\n  ...EmailNotificationsList_notifications_2qqrgr\n  providers: notificationsEmailProviders\n  notificationTypes: notificationsEmailNotificationTypes {\n    key\n    value\n    displayName\n  }\n}\n\nfragment EmailNotificationRow_notification on NotificationsEmailNotificationSummary {\n  emailNotificationSummaryId\n  toEmail\n  toName\n  notificationType\n  createdAt\n  emailAttempts\n  providerTypes\n  wasSent\n  wasDelivered\n  wasOpened\n  wasClicked\n  wasHardBounced\n  wasSoftBounced\n  wasMarkedAsSpam\n}\n\nfragment EmailNotificationsList_notifications_2qqrgr on Query {\n  notifications: notificationsEmailNotificationSummaries(toEmail: $toEmail, notificationType: $notificationType, emailProvider: $emailProvider, dateFrom: $dateFrom, dateTo: $dateTo, pageNumber: $pageNumber, pageSize: 10) {\n    pageNumber\n    pages\n    pageSize\n    totalItems\n    items {\n      emailNotificationSummaryId\n      ...EmailNotificationRow_notification\n    }\n  }\n}\n"
    }
  };
}();
node3.hash = "88fb6342ac492046ac0657585840d648";
var EmailNotificationsListContainerQuery_graphql_default = node3;

// src/email-templates/components/EmailNotificationsListContainer.tsx
import {
  Suspense as Suspense3,
  useCallback as useCallback2,
  useEffect,
  useMemo,
  useState
} from "react";
import { useLazyLoadQuery as useLazyLoadQuery2 } from "react-relay";
import { useLocalStorage } from "react-use";

// ../../node_modules/lodash-es/_freeGlobal.js
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal_default = freeGlobal;

// ../../node_modules/lodash-es/_root.js
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal_default || freeSelf || Function("return this")();
var root_default = root;

// ../../node_modules/lodash-es/_Symbol.js
var Symbol2 = root_default.Symbol;
var Symbol_default = Symbol2;

// ../../node_modules/lodash-es/_getRawTag.js
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var nativeObjectToString = objectProto.toString;
var symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
  try {
    value[symToStringTag] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}
var getRawTag_default = getRawTag;

// ../../node_modules/lodash-es/_objectToString.js
var objectProto2 = Object.prototype;
var nativeObjectToString2 = objectProto2.toString;
function objectToString(value) {
  return nativeObjectToString2.call(value);
}
var objectToString_default = objectToString;

// ../../node_modules/lodash-es/_baseGetTag.js
var nullTag = "[object Null]";
var undefinedTag = "[object Undefined]";
var symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag_default(value) : objectToString_default(value);
}
var baseGetTag_default = baseGetTag;

// ../../node_modules/lodash-es/isObjectLike.js
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_default = isObjectLike;

// ../../node_modules/lodash-es/isSymbol.js
var symbolTag = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike_default(value) && baseGetTag_default(value) == symbolTag;
}
var isSymbol_default = isSymbol;

// ../../node_modules/lodash-es/_trimmedEndIndex.js
var reWhitespace = /\s/;
function trimmedEndIndex(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {
  }
  return index;
}
var trimmedEndIndex_default = trimmedEndIndex;

// ../../node_modules/lodash-es/_baseTrim.js
var reTrimStart = /^\s+/;
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex_default(string) + 1).replace(reTrimStart, "") : string;
}
var baseTrim_default = baseTrim;

// ../../node_modules/lodash-es/isObject.js
function isObject(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_default = isObject;

// ../../node_modules/lodash-es/toNumber.js
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol_default(value)) {
    return NAN;
  }
  if (isObject_default(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject_default(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim_default(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_default = toNumber;

// ../../node_modules/lodash-es/now.js
var now = function() {
  return root_default.Date.now();
};
var now_default = now;

// ../../node_modules/lodash-es/debounce.js
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max;
var nativeMin = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber_default(wait) || 0;
  if (isObject_default(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber_default(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now_default();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now_default());
  }
  function debounced() {
    var time = now_default(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_default = debounce;

// src/email-templates/components/EmailNotificationsListContainer.tsx
import { tryFormatDateHtml } from "shared-lib";
import { classNames, EdSkeleton as EdSkeleton3, Input, LinkButton, Loading } from "shared-ui";

// src/email-templates/components/__generated__/EmailNotificationDetailsQuery.graphql.ts
var node4 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailNotificationId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "tenant",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fromEmail",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fromName",
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "toEmail",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "toName",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "concreteType": "NotificationsEmailNotificationData",
    "kind": "LinkedField",
    "name": "emailNotificationData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "concreteType": "NotificationsReceiver",
    "kind": "LinkedField",
    "name": "receiver",
    "plural": false,
    "selections": [
      v2,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "receiverType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "concreteType": "NotificationsNotificationAttribute",
    "kind": "LinkedField",
    "name": "attributes",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      }
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailNotificationDetailsQuery",
      "selections": [
        {
          "alias": "notification",
          "args": v1,
          "concreteType": "NotificationsEmailNotification",
          "kind": "LinkedField",
          "name": "notificationsEmailNotificationById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationsEmail",
              "kind": "LinkedField",
              "name": "emails",
              "plural": true,
              "selections": [
                v2,
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EmailNotificationEmail_email"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailNotificationDetailsQuery",
      "selections": [
        {
          "alias": "notification",
          "args": v1,
          "concreteType": "NotificationsEmailNotification",
          "kind": "LinkedField",
          "name": "notificationsEmailNotificationById",
          "plural": false,
          "selections": [
            v2,
            v3,
            v4,
            v5,
            v6,
            v7,
            v8,
            v9,
            v10,
            v11,
            v12,
            v13,
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationsEmail",
              "kind": "LinkedField",
              "name": "emails",
              "plural": true,
              "selections": [
                v2,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailId",
                  "storageKey": null
                },
                v4,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "providerType",
                  "storageKey": null
                },
                v5,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "wasSent",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "wasDelivered",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "wasOpened",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "wasClicked",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "wasHardBounced",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "wasSoftBounced",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "wasMarkedAsSpam",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NotificationsEmailEvent",
                  "kind": "LinkedField",
                  "name": "emailEvents",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailEventId",
                      "storageKey": null
                    },
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "occuredAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventData",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventDataDotnetType",
                      "storageKey": null
                    },
                    v2
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "47794c845c64e7cc6fc55bf2062fd0a8",
      "id": null,
      "metadata": {},
      "name": "EmailNotificationDetailsQuery",
      "operationKind": "query",
      "text": "query EmailNotificationDetailsQuery(\n  $id: UUID!\n) {\n  notification: notificationsEmailNotificationById(id: $id) {\n    id\n    emailNotificationId\n    code\n    createdAt\n    tenant\n    fromEmail\n    fromName\n    toEmail\n    toName\n    emailNotificationData {\n      data\n    }\n    receiver {\n      id\n      receiverType\n    }\n    attributes {\n      type\n      value\n    }\n    emails {\n      id\n      ...EmailNotificationEmail_email\n    }\n  }\n}\n\nfragment EmailNotificationEmail_email on NotificationsEmail {\n  id\n  emailId\n  code\n  providerType\n  createdAt\n  wasSent\n  wasDelivered\n  wasOpened\n  wasClicked\n  wasHardBounced\n  wasSoftBounced\n  wasMarkedAsSpam\n  emailEvents {\n    emailEventId\n    createdAt\n    occuredAt\n    eventType\n    eventData\n    eventDataDotnetType\n    id\n  }\n}\n"
    }
  };
}();
node4.hash = "e91cae641b8774442c7de1365547ab0f";
var EmailNotificationDetailsQuery_graphql_default = node4;

// src/email-templates/components/EmailNotificationDetails.tsx
import { useLazyLoadQuery } from "react-relay";
import { Button } from "shared-ui";

// src/email-templates/components/__generated__/EmailNotificationEmail_email.graphql.ts
var node5 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailNotificationEmail_email",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emailId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "providerType",
        "storageKey": null
      },
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasSent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasDelivered",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasOpened",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasClicked",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasHardBounced",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasSoftBounced",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasMarkedAsSpam",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationsEmailEvent",
        "kind": "LinkedField",
        "name": "emailEvents",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailEventId",
            "storageKey": null
          },
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "occuredAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eventType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eventData",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eventDataDotnetType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "NotificationsEmail",
    "abstractKey": null
  };
}();
node5.hash = "86804b06370717d6d57023518c28a1df";
var EmailNotificationEmail_email_graphql_default = node5;

// src/email-templates/components/EmailNotificationEmail.tsx
import { Suspense as Suspense2 } from "react";
import { useFragment as useFragment3 } from "react-relay";
import { timeAgo as timeAgo2 } from "shared-lib";
import {
  BooleanIcon as BooleanIcon2,
  EdColumnCell as EdColumnCell2,
  EdRow as EdRow2,
  EdSkeleton as EdSkeleton2,
  EdTable as EdTable2
} from "shared-ui";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var fragmentDef3 = EmailNotificationEmail_email_graphql_default;
var emailEventRowColumns = [
  { id: "occuredAt", name: "Occurred" },
  { id: "eventType", name: "Event" }
];
var EmailNotificationEmail = ({ fragmentRef }) => {
  const data = useFragment3(
    fragmentDef3,
    fragmentRef
  );
  if (!data) {
    return /* @__PURE__ */ jsx3("div", { children: "Not Found." });
  }
  const rows = (data.emailEvents || []).map((e) => {
    return /* @__PURE__ */ jsx3(EmailNotificationEmailRow, { data: e }, e.emailEventId);
  });
  return /* @__PURE__ */ jsx3(Suspense2, { fallback: /* @__PURE__ */ jsx3(EdSkeleton2, {}), children: /* @__PURE__ */ jsxs3("div", { className: "flex flex-col gap-2 p-2", children: [
    /* @__PURE__ */ jsxs3("div", { className: "text-primary-500 my-2 flex items-center gap-2 border-b p-2 text-lg", children: [
      /* @__PURE__ */ jsx3("div", { children: timeAgo2(data.createdAt) }),
      /* @__PURE__ */ jsx3("div", { children: data.providerType })
    ] }),
    /* @__PURE__ */ jsxs3("div", { className: "flex justify-between gap-2", children: [
      /* @__PURE__ */ jsxs3("div", { className: "flex w-96 flex-col gap-2 border p-2", children: [
        /* @__PURE__ */ jsxs3("div", { className: "my-2 flex items-center gap-2 border-b p-2", children: [
          /* @__PURE__ */ jsx3(BooleanIcon2, { value: data.wasSent }),
          /* @__PURE__ */ jsx3("div", { children: "Sent" })
        ] }),
        /* @__PURE__ */ jsxs3("div", { className: "my-2 flex items-center gap-2 border-b p-2", children: [
          /* @__PURE__ */ jsx3(BooleanIcon2, { value: data.wasDelivered }),
          /* @__PURE__ */ jsx3("div", { children: "Delivered" })
        ] }),
        /* @__PURE__ */ jsxs3("div", { className: "my-2 flex items-center gap-2 border-b p-2", children: [
          /* @__PURE__ */ jsx3(BooleanIcon2, { value: data.wasOpened }),
          /* @__PURE__ */ jsx3("div", { children: "Opened" })
        ] }),
        /* @__PURE__ */ jsxs3("div", { className: "my-2 flex items-center gap-2 border-b p-2", children: [
          /* @__PURE__ */ jsx3(BooleanIcon2, { value: data.wasClicked }),
          /* @__PURE__ */ jsx3("div", { children: "Clicked" })
        ] }),
        /* @__PURE__ */ jsxs3("div", { className: "my-2 flex items-center gap-2 border-b p-2", children: [
          /* @__PURE__ */ jsx3(BooleanIcon2, { value: data.wasMarkedAsSpam }),
          /* @__PURE__ */ jsx3("div", { children: "Marked As Spam" })
        ] }),
        /* @__PURE__ */ jsxs3("div", { className: "my-2 flex items-center gap-2 border-b p-2", children: [
          /* @__PURE__ */ jsx3(BooleanIcon2, { value: data.wasSoftBounced || data.wasHardBounced }),
          /* @__PURE__ */ jsx3("div", { children: "Bounced" }),
          data.wasSoftBounced && /* @__PURE__ */ jsx3("div", { className: "text-danger-500 text-sm", children: /* @__PURE__ */ jsx3("div", { children: "Soft" }) }),
          data.wasHardBounced && /* @__PURE__ */ jsx3("div", { className: "text-danger-500 text-sm", children: /* @__PURE__ */ jsx3("div", { children: "Hard" }) })
        ] })
      ] }),
      /* @__PURE__ */ jsx3("div", { className: "flex-1", children: /* @__PURE__ */ jsx3(
        EdTable2,
        {
          fixedHeight: false,
          classes: "h-full",
          defaultColumns: emailEventRowColumns,
          rows
        }
      ) })
    ] })
  ] }) });
};
var EmailNotificationEmailRow = ({
  data
}) => {
  return /* @__PURE__ */ jsxs3(EdRow2, { bordered: true, rowKey: data.emailEventId, children: [
    /* @__PURE__ */ jsx3(EdColumnCell2, { children: /* @__PURE__ */ jsx3("div", { className: "text-sm text-gray-700", children: timeAgo2(data.occuredAt) }) }),
    /* @__PURE__ */ jsx3(EdColumnCell2, { children: /* @__PURE__ */ jsx3("div", { className: "text-primary-500 text-sm", children: data.eventType }) })
  ] });
};

// src/email-templates/components/EmailNotificationDetails.tsx
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var queryDef = EmailNotificationDetailsQuery_graphql_default;
var EmailNotificationDetails = ({ id, onClose }) => {
  const query = useLazyLoadQuery(
    queryDef,
    { id },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { notification } = query;
  if (!notification) {
    return /* @__PURE__ */ jsx4("div", { children: "Not Found." });
  }
  const eventList = (notification.emails || []).map((e) => {
    return /* @__PURE__ */ jsx4(EmailNotificationEmail, { fragmentRef: e }, e.id);
  });
  return /* @__PURE__ */ jsxs4("div", { className: "flex flex-col gap-2 text-sm", children: [
    /* @__PURE__ */ jsxs4("div", { className: "mb-2 flex items-center gap-2 border-b p-2", children: [
      /* @__PURE__ */ jsx4("div", { className: "p-2", children: /* @__PURE__ */ jsx4(Button, { color: "primary", clicked: onClose, children: "Back" }) }),
      /* @__PURE__ */ jsxs4("div", { className: "text-primary-500 flex gap-2 p-2 text-xl", children: [
        /* @__PURE__ */ jsx4("div", { children: notification.toName }),
        /* @__PURE__ */ jsx4("div", { children: notification.toEmail })
      ] })
    ] }),
    /* @__PURE__ */ jsx4("div", { className: "flex flex-col gap-2 text-sm", children: eventList })
  ] });
};

// src/email-templates/components/EmailNotificationsListContainer.tsx
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var queryDef2 = EmailNotificationsListContainerQuery_graphql_default;
var EmailNotificationsListContainer = ({
  onSelectItem
}) => {
  const [searchTerm, setSearchTerm] = useLocalStorage(
    "email-notifications-search-term",
    ""
  );
  const onQueryChangeHandler = useMemo(
    () => debounce_default((q) => {
      setSearchTerm(q);
      setPageNumber(1);
    }, 500),
    []
  );
  useEffect(() => {
    return () => {
      onQueryChangeHandler.cancel();
    };
  }, [onQueryChangeHandler]);
  const [notificationType, setNotificationType] = useLocalStorage(
    "email-notifications-notification-type",
    ""
  );
  const onSetNotificationType = useCallback2(
    (notificationType2) => {
      setNotificationType(notificationType2);
      setPageNumber(1);
    },
    [setNotificationType]
  );
  const [provider, setProvider] = useLocalStorage(
    "email-notifications-provider",
    ""
  );
  const onSetProvider = useCallback2(
    (provider2) => {
      setProvider(provider2);
      setPageNumber(1);
    },
    [setProvider]
  );
  const [startDate, setStartDate] = useLocalStorage(
    "email-notifications-start-date",
    ""
  );
  const onSetStartDate = useCallback2(
    (date) => {
      setStartDate(date);
      setPageNumber(1);
    },
    [setStartDate]
  );
  const onClearStartDate = useCallback2(() => {
    setStartDate("");
  }, [setStartDate]);
  const [endDate, setEndDate] = useLocalStorage(
    "email-notifications-end-date",
    ""
  );
  const onSetEndDate = useCallback2(
    (date) => {
      setEndDate(date);
      setPageNumber(1);
    },
    [setEndDate]
  );
  const onClearEndDate = useCallback2(() => {
    setEndDate("");
  }, [setEndDate]);
  const [pageNumber, setPageNumber] = useState(1);
  const onPage = useCallback2(
    (page) => {
      setPageNumber(page);
    },
    [setPageNumber]
  );
  const variables = {
    pageNumber
  };
  if (searchTerm) {
    variables.toEmail = searchTerm;
  }
  if (notificationType && notificationType !== "") {
    variables.notificationType = notificationType;
  }
  if (provider && provider !== "") {
    variables.emailProvider = provider;
  }
  if (startDate) {
    variables.dateFrom = startDate.toString();
  }
  if (endDate) {
    variables.dateTo = endDate.toString();
  }
  const [selectedId, setSelectedId] = useState(null);
  const onSelect = useCallback2(
    (e) => {
      setSelectedId(e.emailNotificationSummaryId);
    },
    [setSelectedId]
  );
  const onClearSelected = useCallback2(() => {
    setSelectedId(null);
  }, [setSelectedId]);
  const query = useLazyLoadQuery2(
    queryDef2,
    variables,
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { providers, notificationTypes } = query;
  const providerList = useMemo(() => {
    return (providers ?? []).map((p) => {
      return /* @__PURE__ */ jsx5("option", { value: p, children: p }, p);
    });
  }, [providers]);
  const notificationTypesList = useMemo(() => {
    return (notificationTypes ?? []).map((p) => {
      return /* @__PURE__ */ jsx5("option", { value: p.key, children: p.displayName }, p.key);
    });
  }, [notificationTypes]);
  let selectedDetails = /* @__PURE__ */ jsx5("div", {});
  if (selectedId) {
    selectedDetails = /* @__PURE__ */ jsx5(Suspense3, { fallback: /* @__PURE__ */ jsx5(EdSkeleton3, {}), children: /* @__PURE__ */ jsx5("div", { className: "m-8 border bg-white", children: /* @__PURE__ */ jsx5(EmailNotificationDetails, { id: selectedId, onClose: onClearSelected }) }) });
  }
  return /* @__PURE__ */ jsx5(Suspense3, { fallback: /* @__PURE__ */ jsx5(Loading, { label: "Loading Notifications" }), children: /* @__PURE__ */ jsxs5("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsxs5("div", { className: "flex flex-grow items-center gap-2 divide-x-2 border-b bg-white py-2", children: [
      /* @__PURE__ */ jsxs5("div", { className: "flex items-center gap-2 p-3", children: [
        /* @__PURE__ */ jsx5("label", { className: "text-primary-500 text-sm", children: "Start Date" }),
        /* @__PURE__ */ jsx5("div", { children: /* @__PURE__ */ jsx5(
          Input,
          {
            id: `email-notifications-start-date`,
            type: "date",
            value: tryFormatDateHtml(startDate) ?? "",
            onValueChange: onSetStartDate
          }
        ) }),
        /* @__PURE__ */ jsx5("div", { children: /* @__PURE__ */ jsx5(LinkButton, { clicked: onClearStartDate, label: "Clear" }) })
      ] }),
      /* @__PURE__ */ jsxs5("div", { className: "flex items-center gap-2 p-3", children: [
        /* @__PURE__ */ jsx5("label", { className: "text-primary-500 text-sm", children: "End Date" }),
        /* @__PURE__ */ jsx5("div", { children: /* @__PURE__ */ jsx5(
          Input,
          {
            id: `email-notifications-end-date`,
            type: "date",
            value: tryFormatDateHtml(endDate) ?? "",
            onValueChange: onSetEndDate
          }
        ) }),
        /* @__PURE__ */ jsx5("div", { children: /* @__PURE__ */ jsx5(LinkButton, { clicked: onClearEndDate, label: "Clear" }) })
      ] }),
      /* @__PURE__ */ jsxs5("div", { className: "flex items-center gap-2 p-3", children: [
        /* @__PURE__ */ jsx5("label", { className: "text-primary-500 text-sm", children: "Type" }),
        /* @__PURE__ */ jsx5("div", { children: /* @__PURE__ */ jsxs5(
          "select",
          {
            id: "email-notifications-type",
            name: "email-notifications-type",
            className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
            value: notificationType,
            onChange: (e) => onSetNotificationType(e.target.value),
            children: [
              /* @__PURE__ */ jsx5("option", { value: "", children: "--Select--" }, "none"),
              notificationTypesList
            ]
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs5("div", { className: "flex items-center gap-2 p-3", children: [
        /* @__PURE__ */ jsx5("label", { className: "text-primary-500 text-sm", children: "Provider" }),
        /* @__PURE__ */ jsx5("div", { children: /* @__PURE__ */ jsxs5(
          "select",
          {
            id: "email-notifications-provider",
            name: "email-notifications-provider",
            className: "focus:ring-primary-500 focus:border-primary-500 block w-full rounded-md border-gray-300",
            value: provider,
            onChange: (e) => onSetProvider(e.target.value),
            children: [
              /* @__PURE__ */ jsx5("option", { value: "", children: "-- Select --" }, "none"),
              providerList
            ]
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs5("div", { className: "flex items-center gap-2 p-3", children: [
        /* @__PURE__ */ jsx5("label", { className: "text-primary-500 text-sm", children: "To Email" }),
        /* @__PURE__ */ jsx5("div", { children: /* @__PURE__ */ jsx5(
          Input,
          {
            id: `email-notifications-search-term`,
            value: searchTerm,
            onValueChange: onQueryChangeHandler
          }
        ) })
      ] })
    ] }),
    selectedDetails,
    /* @__PURE__ */ jsx5(
      "div",
      {
        className: classNames("flex-1 p-2", selectedId ? "hidden" : "block"),
        children: /* @__PURE__ */ jsx5(Suspense3, { fallback: /* @__PURE__ */ jsx5(Loading, { label: "Loading Notifications" }), children: /* @__PURE__ */ jsx5(
          EmailNotificationsList,
          {
            fragmentRef: query,
            onPage,
            onSelect
          }
        ) })
      }
    )
  ] }) });
};

// src/email-templates/components/__generated__/EmailTemplateContainer_template.graphql.ts
var node6 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmailTemplateContainer_template",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailNotificationTemplateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tenant",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notificationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "renderingEngine",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailNotificationDefinition",
      "kind": "LinkedField",
      "name": "notificationDefinition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "example",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EmailNotificationTemplate",
  "abstractKey": null
};
node6.hash = "745a4458565b6e80a496b7e27e8122c7";
var EmailTemplateContainer_template_graphql_default = node6;

// src/email-templates/components/__generated__/EmailTemplateContainerMutation.graphql.ts
var node7 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "alias": "response",
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "NotificationsEmailTemplateVersionCreatePayload",
      "kind": "LinkedField",
      "name": "notificationsEmailTemplateVersionCreate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailNotificationTemplatePayload",
          "kind": "LinkedField",
          "name": "emailNotificationTemplatePayload",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EdgeOfEmailNotificationTemplate",
              "kind": "LinkedField",
              "name": "emailNotificationTemplate",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EmailNotificationTemplate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tenant",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "content",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "templateType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "renderingEngine",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailNotificationTemplateId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailTemplateContainerMutation",
      "selections": v1,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailTemplateContainerMutation",
      "selections": v1
    },
    "params": {
      "cacheID": "2c7e9cc55c57793781f7fff8950182a2",
      "id": null,
      "metadata": {},
      "name": "EmailTemplateContainerMutation",
      "operationKind": "mutation",
      "text": "mutation EmailTemplateContainerMutation(\n  $input: NotificationsEmailTemplateVersionCreateInput!\n) {\n  response: notificationsEmailTemplateVersionCreate(input: $input) {\n    emailNotificationTemplatePayload {\n      emailNotificationTemplate {\n        node {\n          id\n          name\n          version\n          createdAt\n          updatedAt\n          tenant\n          content\n          templateType\n          contentType\n          renderingEngine\n          emailNotificationTemplateId\n        }\n      }\n    }\n  }\n}\n"
    }
  };
}();
node7.hash = "1788912b5d4afac95bc116c64344ac1d";
var EmailTemplateContainerMutation_graphql_default = node7;

// src/email-templates/components/EmailTemplateContainer.tsx
import { useCallback as useCallback3, useEffect as useEffect3, useState as useState4 } from "react";
import { useFragment as useFragment4, useMutation as useMutation2 } from "react-relay";
import { createClientMutationId as createClientMutationId2 } from "shared-lib";
import { Spinner as Spinner2 } from "shared-ui";

// src/email-templates/components/EmailTemplateLayout.tsx
import { Suspense as Suspense6 } from "react";
import { Routes, Route } from "react-router-dom";
import { NavigationLink, Spinner } from "shared-ui";

// src/email-templates/components/__generated__/EmailTemplateVersionsQuery.graphql.ts
var node8 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "alias": "versions",
      "args": [
        {
          "kind": "Literal",
          "name": "order",
          "value": {
            "version": "DESC"
          }
        },
        {
          "fields": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "eq",
                  "variableName": "id"
                }
              ],
              "kind": "ObjectValue",
              "name": "templateId"
            }
          ],
          "kind": "ObjectValue",
          "name": "where"
        }
      ],
      "concreteType": "NotificationsEmailNotificationTemplateVersionsConnection",
      "kind": "LinkedField",
      "name": "notificationsEmailNotificationTemplateVersions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailNotificationTemplateVersion",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "content",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailNotificationTemplateVersionId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "templateId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailTemplateVersionsQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailTemplateVersionsQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "0a6ec99395256991805601611e3a48ef",
      "id": null,
      "metadata": {},
      "name": "EmailTemplateVersionsQuery",
      "operationKind": "query",
      "text": "query EmailTemplateVersionsQuery(\n  $id: UUID!\n) {\n  versions: notificationsEmailNotificationTemplateVersions(where: {templateId: {eq: $id}}, order: {version: DESC}) {\n    nodes {\n      id\n      content\n      version\n      createdAt\n      emailNotificationTemplateVersionId\n      templateId\n    }\n  }\n}\n"
    }
  };
}();
node8.hash = "c0e735828018e7a9c30040dc95b01950";
var EmailTemplateVersionsQuery_graphql_default = node8;

// src/email-templates/components/__generated__/EmailTemplateVersionsPublishMutation.graphql.ts
var node9 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailTemplateVersionsPublishMutation",
      "selections": [
        {
          "alias": "response",
          "args": v1,
          "concreteType": "NotificationsEmailTemplateVersionPublishPayload",
          "kind": "LinkedField",
          "name": "notificationsEmailTemplateVersionPublish",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EmailNotificationTemplatePayload",
              "kind": "LinkedField",
              "name": "emailNotificationTemplatePayload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfEmailNotificationTemplate",
                  "kind": "LinkedField",
                  "name": "emailNotificationTemplate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EmailNotificationTemplate",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "EmailTemplateContainer_template"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "userErrors",
                  "plural": true,
                  "selections": [
                    v2,
                    v3
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailTemplateVersionsPublishMutation",
      "selections": [
        {
          "alias": "response",
          "args": v1,
          "concreteType": "NotificationsEmailTemplateVersionPublishPayload",
          "kind": "LinkedField",
          "name": "notificationsEmailTemplateVersionPublish",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EmailNotificationTemplatePayload",
              "kind": "LinkedField",
              "name": "emailNotificationTemplatePayload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfEmailNotificationTemplate",
                  "kind": "LinkedField",
                  "name": "emailNotificationTemplate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EmailNotificationTemplate",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emailNotificationTemplateId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "version",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "createdAt",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "updatedAt",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "tenant",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "content",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "templateType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "notificationType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "contentType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "renderingEngine",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "EmailNotificationDefinition",
                          "kind": "LinkedField",
                          "name": "notificationDefinition",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "example",
                              "storageKey": null
                            },
                            v4
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "userErrors",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    v2,
                    v3
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "54b502673df5285245cdcdb53e70834b",
      "id": null,
      "metadata": {},
      "name": "EmailTemplateVersionsPublishMutation",
      "operationKind": "mutation",
      "text": "mutation EmailTemplateVersionsPublishMutation(\n  $input: NotificationsEmailTemplateVersionPublishInput!\n) {\n  response: notificationsEmailTemplateVersionPublish(input: $input) {\n    emailNotificationTemplatePayload {\n      emailNotificationTemplate {\n        node {\n          ...EmailTemplateContainer_template\n          id\n        }\n      }\n      userErrors {\n        __typename\n        code\n        message\n      }\n    }\n  }\n}\n\nfragment EmailTemplateContainer_template on EmailNotificationTemplate {\n  id\n  emailNotificationTemplateId\n  version\n  createdAt\n  updatedAt\n  tenant\n  name\n  content\n  templateType\n  notificationType\n  contentType\n  renderingEngine\n  notificationDefinition {\n    example\n    id\n  }\n}\n"
    }
  };
}();
node9.hash = "8c23bd09424b42f5fe0ac2c8c466acff";
var EmailTemplateVersionsPublishMutation_graphql_default = node9;

// src/email-templates/components/EmailTemplateVersions.tsx
import { Suspense as Suspense4, useState as useState2 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery4, useMutation } from "react-relay";
import { formatDistance } from "date-fns";
import { createClientMutationId } from "shared-lib";
import {
  Button as Button2,
  classNames as classNames2,
  EdColumnCell as EdColumnCell3,
  EdRow as EdRow3,
  EdTable as EdTable3,
  Saving
} from "shared-ui";

// src/email-templates/components/__generated__/EmailTemplateEditPreviewQuery.graphql.ts
var node10 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "content"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }, v2 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "renderingEngine"
  }, v3 = [
    {
      "alias": "emailTemplatePreview",
      "args": [
        {
          "kind": "Variable",
          "name": "content",
          "variableName": "content"
        },
        {
          "kind": "Variable",
          "name": "renderingEngine",
          "variableName": "renderingEngine"
        },
        {
          "kind": "Variable",
          "name": "templateId",
          "variableName": "id"
        }
      ],
      "concreteType": "EmailNotificationPreview",
      "kind": "LinkedField",
      "name": "notificationsEmailNotificationTemplateGeneratePreview",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "error",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1,
        v2
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailTemplateEditPreviewQuery",
      "selections": v3,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0,
        v2
      ],
      "kind": "Operation",
      "name": "EmailTemplateEditPreviewQuery",
      "selections": v3
    },
    "params": {
      "cacheID": "f2597b28cbb06e091513a1f497fffb07",
      "id": null,
      "metadata": {},
      "name": "EmailTemplateEditPreviewQuery",
      "operationKind": "query",
      "text": "query EmailTemplateEditPreviewQuery(\n  $id: UUID!\n  $content: String!\n  $renderingEngine: String\n) {\n  emailTemplatePreview: notificationsEmailNotificationTemplateGeneratePreview(templateId: $id, content: $content, renderingEngine: $renderingEngine) {\n    content\n    error\n  }\n}\n"
    }
  };
}();
node10.hash = "25880220dd54d76c8ad1057733c54739";
var EmailTemplateEditPreviewQuery_graphql_default = node10;

// src/email-templates/components/EmailTemplateEditPreview.tsx
var import_lodash = __toESM(require_lodash());
import { useLazyLoadQuery as useLazyLoadQuery3 } from "react-relay";

// src/email-templates/components/EmailTemplatePreview.tsx
import { createRef, useEffect as useEffect2 } from "react";
import { Fragment, jsx as jsx6 } from "react/jsx-runtime";
var EmailTemplatePreview = ({ value }) => {
  const iframeRef = createRef();
  useEffect2(() => {
    if (iframeRef.current) {
      const doc = iframeRef.current.contentDocument;
      doc?.open();
      doc?.write(value);
      doc?.close();
    }
  }, [iframeRef, value]);
  return /* @__PURE__ */ jsx6(Fragment, { children: /* @__PURE__ */ jsx6("iframe", { className: "flex h-full min-h-[70vh] w-full", ref: iframeRef }) });
};

// src/email-templates/components/EmailTemplateEditPreview.tsx
import { jsx as jsx7 } from "react/jsx-runtime";
var queryDef3 = EmailTemplateEditPreviewQuery_graphql_default;
var EmailTemplateEditPreview = (props) => {
  const { emailNotificationTemplateId, value, renderingEngine } = props;
  const data = useLazyLoadQuery3(
    queryDef3,
    {
      id: emailNotificationTemplateId,
      content: value,
      renderingEngine
    },
    {
      fetchPolicy: "network-only"
    }
  );
  if (data?.emailTemplatePreview?.error) {
    return /* @__PURE__ */ jsx7(EmailTemplatePreview, { value: import_lodash.default.escape(data.emailTemplatePreview.error) });
  }
  let preview = data.emailTemplatePreview?.content || "";
  if (props.isText) {
    preview = `<div style='white-space: pre-wrap;'>${data.emailTemplatePreview?.content}</div>`;
  }
  return /* @__PURE__ */ jsx7(EmailTemplatePreview, { value: preview });
};

// src/email-templates/components/EmailTemplateVersions.tsx
import { jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var EmailTemplateVersions = ({ templateId, isText }) => {
  const [renderedValue, setRenderedValue] = useState2("");
  const { versions } = useLazyLoadQuery4(
    EmailTemplateVersionsQuery_graphql_default,
    { id: templateId },
    { fetchPolicy: "store-and-network" }
  );
  const [commit, isSaving] = useMutation(
    EmailTemplateVersionsPublishMutation_graphql_default
  );
  if (isSaving) {
    return /* @__PURE__ */ jsx8(Saving, {});
  }
  const publish = ({ versionId }) => {
    const clientMutationId = createClientMutationId();
    commit({
      variables: {
        input: {
          clientMutationId,
          versionId
        }
      }
    });
  };
  return /* @__PURE__ */ jsxs6("div", { className: "flex h-full justify-between gap-5", children: [
    /* @__PURE__ */ jsxs6(
      "div",
      {
        className: classNames2(
          "h-full w-full flex-col lg:flex lg:w-6/12",
          renderedValue == "" ? "lg:flex-grow" : "hidden"
        ),
        children: [
          /* @__PURE__ */ jsx8("div", { className: "flex justify-between pb-2", children: /* @__PURE__ */ jsx8("div", { className: "text-lg", children: "Versions" }) }),
          /* @__PURE__ */ jsx8(
            EdTable3,
            {
              defaultColumns: [
                { id: "version", name: "Version" },
                { id: "createdAt", name: "Created At" }
              ],
              rows: versions?.nodes?.map((props, key) => /* @__PURE__ */ jsxs6(
                EdRow3,
                {
                  rowKey: String(key),
                  clicked: () => {
                    setRenderedValue(props?.content || "");
                  },
                  children: [
                    /* @__PURE__ */ jsx8(EdColumnCell3, { children: props?.version }),
                    /* @__PURE__ */ jsx8(EdColumnCell3, { children: formatDistance(new Date(props?.createdAt || ""), /* @__PURE__ */ new Date(), {
                      addSuffix: true
                    }) }),
                    /* @__PURE__ */ jsx8(EdColumnCell3, { children: /* @__PURE__ */ jsx8(
                      Button2,
                      {
                        onClick: () => {
                          if (props?.emailNotificationTemplateVersionId) {
                            publish({
                              versionId: props.emailNotificationTemplateVersionId
                            });
                          }
                        },
                        children: "Publish"
                      }
                    ) })
                  ]
                },
                key
              ))
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxs6(
      "div",
      {
        className: classNames2(
          "h-full w-6/12 flex-grow flex-col",
          renderedValue == "" ? "hidden" : "flex"
        ),
        children: [
          /* @__PURE__ */ jsxs6("div", { className: "flex items-baseline justify-between pb-2 text-lg", children: [
            "Preview",
            /* @__PURE__ */ jsx8(Button2, { onClick: () => setRenderedValue(""), className: "lg:hidden", children: "Show Versions" })
          ] }),
          /* @__PURE__ */ jsx8(Suspense4, { fallback: "Loading...", children: /* @__PURE__ */ jsx8(
            EmailTemplateEditPreview,
            {
              value: renderedValue,
              emailNotificationTemplateId: templateId,
              isText,
              renderingEngine: null
            }
          ) })
        ]
      }
    )
  ] });
};

// src/email-templates/components/EmailTemplateEditor.tsx
import { Suspense as Suspense5, useState as useState3 } from "react";
import Editor from "@monaco-editor/react";
import { useDebounce, useToggle } from "shared-lib";
import { Button as Button3, classNames as classNames3 } from "shared-ui";
import { Fragment as Fragment2, jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var EmailTemplateEditor = ({
  id,
  value,
  onSaveVersion,
  isText = false,
  emailNotificationTemplateId,
  defaultRenderingEngine: defaultRenderingEngine2
}) => {
  const [editorOpen, toggleEditorOpen] = useToggle(true);
  const [html, setHTML] = useState3(value);
  const [renderingEngine, setRenderingEngine] = useState3(
    defaultRenderingEngine2
  );
  const debouncedHTML = useDebounce(html, 1e3);
  if (!id) {
    return /* @__PURE__ */ jsx9(Fragment2, { children: "Loading" });
  }
  return /* @__PURE__ */ jsxs7("div", { className: "flex h-full gap-5", children: [
    /* @__PURE__ */ jsxs7(
      "div",
      {
        className: classNames3(
          "h-full w-full flex-col lg:flex lg:w-6/12",
          editorOpen ? "" : "hidden "
        ),
        children: [
          /* @__PURE__ */ jsxs7("div", { className: "flex justify-between pb-2", children: [
            /* @__PURE__ */ jsx9("div", { className: "flex flex-grow justify-between pb-2", children: /* @__PURE__ */ jsx9("span", { className: "text-lg", children: "Editor" }) }),
            /* @__PURE__ */ jsxs7("div", { className: "flex gap-2 lg:hidden", children: [
              /* @__PURE__ */ jsx9(Button3, { onClick: toggleEditorOpen, children: "Show Preview" }),
              /* @__PURE__ */ jsx9(
                Button3,
                {
                  color: "primary",
                  className: "",
                  onClick: () => onSaveVersion({
                    id,
                    value: html,
                    renderingEngine: renderingEngine.id
                  }),
                  children: "Save"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsx9(
            Editor,
            {
              className: "max-h-[60vh] min-h-[60vh]",
              onChange: (e) => setHTML(e || ""),
              defaultLanguage: "html",
              defaultValue: html,
              options: {
                minimap: {
                  enabled: false
                }
              }
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxs7(
      "div",
      {
        className: classNames3(
          "h-full flex-grow flex-col",
          editorOpen ? "hidden lg:flex" : ""
        ),
        children: [
          /* @__PURE__ */ jsxs7("div", { className: "flex justify-between pb-4", children: [
            /* @__PURE__ */ jsx9("span", { className: "text-lg", children: "Preview" }),
            /* @__PURE__ */ jsxs7("div", { className: "flex gap-2", children: [
              /* @__PURE__ */ jsx9(Button3, { className: "lg:hidden", onClick: toggleEditorOpen, children: "Show Editor" }),
              /* @__PURE__ */ jsx9(
                RenderingEngineTypesSelect,
                {
                  label: "Engine",
                  showAny: false,
                  selected: renderingEngine,
                  onSelected: (x) => setRenderingEngine(x)
                }
              ),
              /* @__PURE__ */ jsx9("div", { className: "self-end", children: /* @__PURE__ */ jsx9(
                Button3,
                {
                  color: "primary",
                  className: "",
                  onClick: () => onSaveVersion({
                    id,
                    value: html,
                    renderingEngine: renderingEngine.id
                  }),
                  children: "Save"
                }
              ) })
            ] })
          ] }),
          /* @__PURE__ */ jsx9(Suspense5, { fallback: "Loading...", children: /* @__PURE__ */ jsx9(
            EmailTemplateEditPreview,
            {
              value: debouncedHTML,
              emailNotificationTemplateId,
              isText,
              renderingEngine: renderingEngine.id
            }
          ) })
        ]
      }
    )
  ] });
};
var DefaultNotificationTemplateEditor = (props) => {
  return /* @__PURE__ */ jsx9(EmailTemplateEditor, { ...props });
};

// src/email-templates/components/EmailTemplateLayout.tsx
import { Fragment as Fragment3, jsx as jsx10, jsxs as jsxs8 } from "react/jsx-runtime";
var EmailTemplateLayout = ({
  id,
  emailNotificationTemplateId,
  title,
  value,
  onSaveVersion,
  isText,
  selectedPage,
  setSelectedPage,
  renderingEngine
}) => {
  if (!emailNotificationTemplateId) {
    return /* @__PURE__ */ jsx10(Spinner, {});
  }
  return /* @__PURE__ */ jsx10(Fragment3, { children: /* @__PURE__ */ jsxs8(Suspense6, { fallback: "Loading...", children: [
    /* @__PURE__ */ jsxs8("h1", { className: "pb-2 pt-5 text-2xl xl:pt-0", children: [
      title,
      " - ",
      renderingEngine,
      " template"
    ] }),
    /* @__PURE__ */ jsxs8("nav", { className: "mb-4 flex w-full flex-row", children: [
      /* @__PURE__ */ jsx10(
        NavigationLink,
        {
          onClick: () => setSelectedPage("preview"),
          active: selectedPage === "preview",
          to: "./preview",
          children: "Preview"
        }
      ),
      /* @__PURE__ */ jsx10(
        NavigationLink,
        {
          onClick: () => setSelectedPage("editor"),
          active: selectedPage === "editor",
          to: "./editor",
          children: "Editor"
        }
      ),
      /* @__PURE__ */ jsx10(
        NavigationLink,
        {
          onClick: () => setSelectedPage("versions"),
          active: selectedPage === "versions",
          to: "./versions",
          children: "Versions"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs8(Routes, { children: [
      /* @__PURE__ */ jsx10(
        Route,
        {
          path: "/",
          element: /* @__PURE__ */ jsx10(
            EmailTemplateEditPreview,
            {
              value,
              isText,
              emailNotificationTemplateId,
              renderingEngine: null
            }
          )
        }
      ),
      /* @__PURE__ */ jsx10(
        Route,
        {
          path: "/preview",
          element: /* @__PURE__ */ jsx10(
            EmailTemplateEditPreview,
            {
              value,
              isText,
              emailNotificationTemplateId,
              renderingEngine: null
            }
          )
        }
      ),
      /* @__PURE__ */ jsx10(
        Route,
        {
          path: "/editor",
          element: /* @__PURE__ */ jsx10(
            EmailTemplateEditor,
            {
              emailNotificationTemplateId,
              id,
              value,
              onSaveVersion,
              isText,
              defaultRenderingEngine: {
                id: renderingEngine.toUpperCase(),
                name: renderingEngine
              }
            }
          )
        }
      ),
      /* @__PURE__ */ jsx10(
        Route,
        {
          path: "/versions",
          element: /* @__PURE__ */ jsx10(
            EmailTemplateVersions,
            {
              templateId: emailNotificationTemplateId,
              value,
              isText
            }
          )
        }
      )
    ] })
  ] }) });
};

// src/email-templates/components/EmailTemplateContainer.tsx
import { jsx as jsx11, jsxs as jsxs9 } from "react/jsx-runtime";
var fragmentDef4 = EmailTemplateContainer_template_graphql_default;
var mutationDef = EmailTemplateContainerMutation_graphql_default;
var EmailTemplateContainer = ({
  fragmentRef,
  onSetExampleJson
}) => {
  const data = useFragment4(
    fragmentDef4,
    fragmentRef
  );
  const [commit, isSaving] = useMutation2(mutationDef);
  const saveVersion = useCallback3(({ id, value, renderingEngine }) => {
    const clientMutationId = createClientMutationId2();
    commit({
      variables: {
        input: {
          clientMutationId,
          id,
          model: {
            content: value,
            renderingEngine
          }
        }
      }
    });
  }, []);
  useEffect3(() => {
    if (data?.notificationDefinition?.example) {
      onSetExampleJson(
        JSON.stringify(
          JSON.parse(data.notificationDefinition.example),
          null,
          2
        )
      );
    } else {
      onSetExampleJson("");
    }
  }, [data?.notificationDefinition?.example, onSetExampleJson]);
  const [selectedPage, setSelectedPage] = useState4("preview");
  useEffect3(() => {
    setSelectedPage("preview");
  }, [data.templateType]);
  return /* @__PURE__ */ jsxs9("div", { children: [
    isSaving ? /* @__PURE__ */ jsx11(Spinner2, {}) : void 0,
    /* @__PURE__ */ jsx11(
      EmailTemplateLayout,
      {
        id: data.emailNotificationTemplateId,
        title: data.name,
        value: data.content,
        emailNotificationTemplateId: data.emailNotificationTemplateId,
        onSaveVersion: saveVersion,
        isText: data.templateType !== "BODY_HTML",
        selectedPage,
        setSelectedPage,
        templateType: data.templateType,
        tenantId: data.tenant,
        notificationType: data.notificationType,
        renderingEngine: data.renderingEngine
      }
    )
  ] });
};

// src/email-templates/components/__generated__/EmailTemplateCreateButtonMutation.graphql.ts
var node11 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "tenant",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "emailNotificationTemplateId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "notificationType",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailTemplateCreateButtonMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "NotificationsEmailTemplateCreatePayload",
          "kind": "LinkedField",
          "name": "notificationsEmailTemplateCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EmailNotificationTemplatePayload",
              "kind": "LinkedField",
              "name": "emailNotificationTemplatePayload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfEmailNotificationTemplate",
                  "kind": "LinkedField",
                  "name": "emailNotificationTemplate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EmailNotificationTemplate",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v2,
                        v3,
                        v4
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "userErrors",
                  "plural": true,
                  "selections": [
                    v5,
                    v6
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailTemplateCreateButtonMutation",
      "selections": [
        {
          "alias": "result",
          "args": v1,
          "concreteType": "NotificationsEmailTemplateCreatePayload",
          "kind": "LinkedField",
          "name": "notificationsEmailTemplateCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EmailNotificationTemplatePayload",
              "kind": "LinkedField",
              "name": "emailNotificationTemplatePayload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EdgeOfEmailNotificationTemplate",
                  "kind": "LinkedField",
                  "name": "emailNotificationTemplate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EmailNotificationTemplate",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        v2,
                        v3,
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "userErrors",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    v5,
                    v6
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "b67fbf25dfcb9c5217f0979ecaca8e1b",
      "id": null,
      "metadata": {},
      "name": "EmailTemplateCreateButtonMutation",
      "operationKind": "mutation",
      "text": "mutation EmailTemplateCreateButtonMutation(\n  $input: NotificationsEmailTemplateCreateInput!\n) {\n  result: notificationsEmailTemplateCreate(input: $input) {\n    emailNotificationTemplatePayload {\n      emailNotificationTemplate {\n        node {\n          tenant\n          emailNotificationTemplateId\n          notificationType\n          id\n        }\n      }\n      userErrors {\n        __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
    }
  };
}();
node11.hash = "1e610df3484f27bc9effc32e27d39d85";
var EmailTemplateCreateButtonMutation_graphql_default = node11;

// src/email-templates/components/EmailTemplateCreateButton.tsx
import { useMutation as useMutation3 } from "react-relay";
import { createClientMutationId as createClientMutationId3 } from "shared-lib";
import { Button as Button4, Spinner as Spinner3 } from "shared-ui";
import { jsx as jsx12, jsxs as jsxs10 } from "react/jsx-runtime";
var mutationDef2 = EmailTemplateCreateButtonMutation_graphql_default;
var defaultRenderingEngine = "RAZOR";
var EmailTemplateCreateButton = ({
  tenantId,
  notificationTypeKey,
  templateType,
  onCreateSucceeded,
  onCreateFail
}) => {
  const name = `${notificationTypeKey}.${templateType}`;
  const [commit, isSaving] = useMutation3(mutationDef2);
  const onCreate = ({ templateType: templateType2 }) => () => {
    commit({
      variables: {
        input: {
          clientMutationId: createClientMutationId3(),
          model: {
            content: "",
            notificationType: notificationTypeKey,
            renderingEngine: defaultRenderingEngine,
            templateType: templateType2,
            tenantId
          }
        }
      },
      onCompleted(data) {
        if (data?.result?.emailNotificationTemplatePayload?.emailNotificationTemplate == null) {
          onCreateFail("No Data Returned From Server");
          return;
        }
        const { emailNotificationTemplateId, notificationType, tenant } = data.result.emailNotificationTemplatePayload.emailNotificationTemplate.node;
        onCreateSucceeded({
          templateType: templateType2,
          emailNotificationTemplateId,
          notificationType,
          tenant
        });
      }
    });
  };
  return /* @__PURE__ */ jsxs10(
    "div",
    {
      className: "flex justify-between rounded bg-gray-100 px-3 py-5 text-gray-700",
      onClick: onCreate({ templateType }),
      children: [
        /* @__PURE__ */ jsx12("div", { children: name }),
        /* @__PURE__ */ jsx12("div", { children: /* @__PURE__ */ jsx12(Button4, { children: isSaving ? /* @__PURE__ */ jsx12(Spinner3, {}) : "Create" }) })
      ]
    }
  );
};

// src/email-templates/components/__generated__/EmailTemplateRow_template.graphql.ts
var node12 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmailTemplateRow_template",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailNotificationTemplateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notificationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "renderingEngine",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tenant",
      "storageKey": null
    }
  ],
  "type": "EmailNotificationTemplate",
  "abstractKey": null
};
node12.hash = "ce9bb361267a8b44de7f461e2e69dd1c";
var EmailTemplateRow_template_graphql_default = node12;

// src/email-templates/components/EmailTemplateRow.tsx
import { useCallback as useCallback4 } from "react";
import { useFragment as useFragment5 } from "react-relay";
import {
  EdActionCell,
  EdColumnCell as EdColumnCell4,
  EdRow as EdRow4,
  LinkButton as LinkButton2,
  SortDir
} from "shared-ui";
import { formatDateTime } from "shared-lib";
import { jsx as jsx13, jsxs as jsxs11 } from "react/jsx-runtime";
var fragmentDef5 = EmailTemplateRow_template_graphql_default;
var EmailTemplateRowColumns = [
  { id: "title", name: "Title" },
  { id: "type", name: "Type" },
  { id: "employer", name: "Employer" },
  { id: "dateAdded", name: "Date Added", sort: true },
  {
    id: "updatedOn",
    name: "Last Update",
    sort: true,
    sortValue: SortDir.Desc
  },
  { id: "notificationType", name: "Notification Type" },
  { id: "syntax", name: "Syntax" },
  { id: "contentType", name: "Content Type" }
];
var EmailTemplateRow = ({
  fragmentRef,
  tenantName,
  onSelect
}) => {
  const data = useFragment5(fragmentDef5, fragmentRef);
  const select = useCallback4(() => {
    onSelect(data);
  }, [data, onSelect]);
  return /* @__PURE__ */ jsxs11(EdRow4, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx13(EdColumnCell4, { children: data.name }),
    /* @__PURE__ */ jsx13(EdColumnCell4, { children: data.contentType }),
    /* @__PURE__ */ jsx13(EdColumnCell4, { children: tenantName }),
    /* @__PURE__ */ jsx13(EdColumnCell4, { children: formatDateTime(data.createdAt) }),
    /* @__PURE__ */ jsx13(EdColumnCell4, { children: formatDateTime(data.updatedAt) }),
    /* @__PURE__ */ jsx13(EdColumnCell4, { children: data.notificationType }),
    /* @__PURE__ */ jsx13(EdColumnCell4, { children: data.renderingEngine }),
    /* @__PURE__ */ jsx13(EdColumnCell4, { children: data.templateType }),
    /* @__PURE__ */ jsx13(EdActionCell, { children: /* @__PURE__ */ jsx13(LinkButton2, { label: "Select", clicked: select }) })
  ] });
};

// src/email-templates/components/EmailTemplateSelector.tsx
import { Suspense as Suspense7, useState as useState7 } from "react";
import { Button as Button5 } from "shared-ui";

// src/notifications/components/__generated__/NotificationTypesSelectQuery.graphql.ts
var node13 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = [
    {
      "alias": "notifications",
      "args": [
        {
          "kind": "Variable",
          "name": "order",
          "variableName": "order"
        }
      ],
      "concreteType": "EmailNotificationDefinition",
      "kind": "LinkedField",
      "name": "notificationsEmailNotificationDefinitions",
      "plural": true,
      "selections": [
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailNotificationDefinitionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailNotificationType",
          "kind": "LinkedField",
          "name": "notificationType",
          "plural": false,
          "selections": [
            v1,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "htmlTemplateName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subjectTemplateName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "textTemplateName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "NotificationTypesSelectQuery",
      "selections": v2,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "NotificationTypesSelectQuery",
      "selections": v2
    },
    "params": {
      "cacheID": "ae7092aae2e852ba87cf566fc68e4224",
      "id": null,
      "metadata": {},
      "name": "NotificationTypesSelectQuery",
      "operationKind": "query",
      "text": "query NotificationTypesSelectQuery(\n  $order: [EmailNotificationDefinitionSort!]!\n) {\n  notifications: notificationsEmailNotificationDefinitions(order: $order) {\n    id\n    emailNotificationDefinitionId\n    displayName\n    description\n    notificationType {\n      id\n      key\n      htmlTemplateName\n      subjectTemplateName\n      textTemplateName\n    }\n  }\n}\n"
    }
  };
}();
node13.hash = "153c7e9c02a69b44d7c15a3676d1f205";
var NotificationTypesSelectQuery_graphql_default = node13;

// src/notifications/components/NotificationTypesSelect.tsx
import { useCallback as useCallback5, useState as useState5 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery5 } from "react-relay";
import { Combobox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { Fragment as Fragment4, jsx as jsx14, jsxs as jsxs12 } from "react/jsx-runtime";
var AnyNotificationType = {
  id: null,
  emailNotificationDefinitionId: null,
  notificationType: null,
  displayName: "Any"
};
var queryDef4 = NotificationTypesSelectQuery_graphql_default;
var NotificationTypesSelect = ({
  notificationType,
  onSelected,
  label
}) => {
  const [selected, setSelected] = useState5(notificationType);
  const [filter, setFilter] = useState5("");
  const changed = useCallback5(
    (e) => {
      if (!e) {
        return;
      }
      setSelected(e);
      onSelected(e);
    },
    [onSelected, setSelected]
  );
  const order = [{ displayName: "ASC" }];
  const query = useLazyLoadQuery5(
    queryDef4,
    { order },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { notifications } = query;
  const filtered = filter === "" ? notifications : notifications.filter(
    (e) => e.displayName.toLowerCase().replace(/\s+/g, "").includes(filter.toLowerCase().replace(/\s+/g, ""))
  );
  return /* @__PURE__ */ jsxs12("div", { className: "", children: [
    label && /* @__PURE__ */ jsx14("label", { className: "block text-sm font-medium text-gray-700", children: label }),
    /* @__PURE__ */ jsx14(Combobox, { value: selected, onChange: changed, children: /* @__PURE__ */ jsxs12("div", { className: "relative mt-1", children: [
      /* @__PURE__ */ jsxs12("div", { className: "relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm", children: [
        /* @__PURE__ */ jsx14(
          Combobox.Input,
          {
            className: "w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0",
            displayValue: (e) => e?.displayName,
            onChange: (event) => setFilter(event.target.value)
          }
        ),
        /* @__PURE__ */ jsx14(Combobox.Button, { className: "absolute inset-y-0 right-0 flex items-center pr-2", children: /* @__PURE__ */ jsx14(
          ChevronUpDownIcon,
          {
            className: "h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx14(
        Transition,
        {
          as: "div",
          leave: "transition ease-in duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          afterLeave: () => setFilter(""),
          children: /* @__PURE__ */ jsx14(Combobox.Options, { className: "absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: filtered.length === 0 && filter !== "" ? /* @__PURE__ */ jsx14("div", { className: "relative cursor-default select-none px-4 py-2 text-gray-700", children: "Nothing found." }) : [AnyNotificationType, ...filtered].map((e) => /* @__PURE__ */ jsx14(
            Combobox.Option,
            {
              className: ({ active }) => `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? "bg-info-600 text-white" : "text-gray-900"}`,
              value: e,
              children: ({ selected: selected2, active }) => /* @__PURE__ */ jsxs12(Fragment4, { children: [
                /* @__PURE__ */ jsx14(
                  "span",
                  {
                    className: `block truncate ${selected2 ? "font-medium" : "font-normal"}`,
                    children: e.displayName
                  }
                ),
                selected2 ? /* @__PURE__ */ jsx14(
                  "span",
                  {
                    className: `absolute inset-y-0 left-0 flex items-center pl-3 ${active ? "text-white" : "text-info-600"}`,
                    children: /* @__PURE__ */ jsx14(CheckIcon, { className: "h-5 w-5", "aria-hidden": "true" })
                  }
                ) : null
              ] })
            },
            e.id
          )) })
        }
      )
    ] }) })
  ] });
};

// src/tenants/components/__generated__/TenantSelect_tenants_RefreshQuery.graphql.ts
var node14 = function() {
  var v0 = [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "name"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TenantSelect_tenants_RefreshQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "name"
            }
          ],
          "kind": "FragmentSpread",
          "name": "TenantSelect_tenants"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TenantSelect_tenants_RefreshQuery",
      "selections": [
        {
          "alias": "tenants",
          "args": [
            {
              "kind": "Literal",
              "name": "order",
              "value": {
                "name": "ASC"
              }
            },
            {
              "fields": [
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "contains",
                      "variableName": "name"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "name"
                }
              ],
              "kind": "ObjectValue",
              "name": "where"
            }
          ],
          "concreteType": "AccountsEmployersConnection",
          "kind": "LinkedField",
          "name": "accountsEmployers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Employer",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9b6248d67d4a88f8ee1f9abfe3139604",
      "id": null,
      "metadata": {},
      "name": "TenantSelect_tenants_RefreshQuery",
      "operationKind": "query",
      "text": 'query TenantSelect_tenants_RefreshQuery(\n  $name: String = ""\n) {\n  ...TenantSelect_tenants_2aiVTE\n}\n\nfragment TenantSelect_tenants_2aiVTE on Query {\n  tenants: accountsEmployers(order: {name: ASC}, where: {name: {contains: $name}}) {\n    nodes {\n      id\n      name\n      entityId\n    }\n  }\n}\n'
    }
  };
}();
node14.hash = "36084e0d418290724aa2eebf9095368e";
var TenantSelect_tenants_RefreshQuery_graphql_default = node14;

// src/tenants/components/__generated__/TenantSelect_tenants.graphql.ts
var node15 = {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "name"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": TenantSelect_tenants_RefreshQuery_graphql_default
    }
  },
  "name": "TenantSelect_tenants",
  "selections": [
    {
      "alias": "tenants",
      "args": [
        {
          "kind": "Literal",
          "name": "order",
          "value": {
            "name": "ASC"
          }
        },
        {
          "fields": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "contains",
                  "variableName": "name"
                }
              ],
              "kind": "ObjectValue",
              "name": "name"
            }
          ],
          "kind": "ObjectValue",
          "name": "where"
        }
      ],
      "concreteType": "AccountsEmployersConnection",
      "kind": "LinkedField",
      "name": "accountsEmployers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
node15.hash = "36084e0d418290724aa2eebf9095368e";
var TenantSelect_tenants_graphql_default = node15;

// src/tenants/components/TenantSelect.tsx
import { useCallback as useCallback6, useEffect as useEffect4, useState as useState6 } from "react";
import { useRefetchableFragment } from "react-relay";
import { Combobox as Combobox2, Transition as Transition2 } from "@headlessui/react";
import { CheckIcon as CheckIcon2, ChevronUpDownIcon as ChevronUpDownIcon2 } from "@heroicons/react/20/solid";
import { useDebounce as useDebounce2 } from "shared-lib";
import { Fragment as Fragment5, jsx as jsx15, jsxs as jsxs13 } from "react/jsx-runtime";
var AnyTenant = { entityId: null, name: "Any" };
var queryDef5 = TenantSelect_tenants_graphql_default;
var TenantSelect = ({
  tenant,
  onSelected,
  label,
  placeHolder,
  queryRef
}) => {
  const [selected, setSelected] = useState6(tenant ?? AnyTenant);
  const [filter, setFilter] = useState6("");
  const debouncedFilter = useDebounce2(filter, 500);
  const changed = useCallback6(
    (e) => {
      if (!e) {
        return;
      }
      setSelected(e);
      onSelected(e);
    },
    [onSelected, setSelected]
  );
  const [query, refetch] = useRefetchableFragment(queryDef5, queryRef);
  useEffect4(() => {
    refetch({
      name: debouncedFilter
    });
  }, [refetch, debouncedFilter]);
  const tenants = query?.tenants?.nodes || [];
  return /* @__PURE__ */ jsxs13("div", { className: "", children: [
    label && /* @__PURE__ */ jsx15("label", { className: "block text-sm font-medium text-gray-700", children: label }),
    /* @__PURE__ */ jsx15(Combobox2, { value: selected, onChange: changed, children: /* @__PURE__ */ jsxs13("div", { className: "relative mt-1", children: [
      /* @__PURE__ */ jsxs13("div", { className: "relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm", children: [
        /* @__PURE__ */ jsx15(
          Combobox2.Input,
          {
            placeholder: placeHolder,
            className: "w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0",
            displayValue: (e) => e?.name,
            onChange: (event) => setFilter(event.target.value)
          },
          "filter-search"
        ),
        /* @__PURE__ */ jsx15(Combobox2.Button, { className: "absolute inset-y-0 right-0 flex items-center pr-2", children: /* @__PURE__ */ jsx15(
          ChevronUpDownIcon2,
          {
            className: "h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx15(
        Transition2,
        {
          as: "div",
          leave: "transition ease-in duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          afterLeave: () => setFilter(""),
          children: /* @__PURE__ */ jsx15(Combobox2.Options, { className: "absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: tenants?.length === 0 && filter !== "" ? /* @__PURE__ */ jsx15("div", { className: "relative cursor-default select-none px-4 py-2 text-gray-700", children: "Nothing found." }) : [AnyTenant, ...tenants]?.map((e) => /* @__PURE__ */ jsx15(
            Combobox2.Option,
            {
              className: ({ active }) => `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? "bg-info-600 text-white" : "text-gray-900"}`,
              value: e,
              children: ({ selected: selected2, active }) => /* @__PURE__ */ jsxs13(Fragment5, { children: [
                /* @__PURE__ */ jsx15(
                  "span",
                  {
                    className: `block truncate ${selected2 ? "font-medium" : "font-normal"}`,
                    children: e.name
                  }
                ),
                selected2 ? /* @__PURE__ */ jsx15(
                  "span",
                  {
                    className: `absolute inset-y-0 left-0 flex items-center pl-3 ${active ? "text-white" : "text-info-600"}`,
                    children: /* @__PURE__ */ jsx15(CheckIcon2, { className: "h-5 w-5", "aria-hidden": "true" })
                  }
                ) : null
              ] })
            },
            e.entityId
          )) })
        }
      )
    ] }) })
  ] }, "search-box");
};

// src/tenants/components/__generated__/TenantSelectContainerQuery.graphql.ts
var node16 = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TenantSelectContainerQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "TenantSelect_tenants"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TenantSelectContainerQuery",
    "selections": [
      {
        "alias": "tenants",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": {
              "name": "ASC"
            }
          },
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Literal",
                    "name": "contains",
                    "value": ""
                  }
                ],
                "kind": "ObjectValue",
                "name": "name"
              }
            ],
            "kind": "ObjectValue",
            "name": "where"
          }
        ],
        "concreteType": "AccountsEmployersConnection",
        "kind": "LinkedField",
        "name": "accountsEmployers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Employer",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": 'accountsEmployers(order:{"name":"ASC"},where:{"name":{"contains":""}})'
      }
    ]
  },
  "params": {
    "cacheID": "96d33b7de95d0aa9f80217e6da69cdeb",
    "id": null,
    "metadata": {},
    "name": "TenantSelectContainerQuery",
    "operationKind": "query",
    "text": 'query TenantSelectContainerQuery {\n  ...TenantSelect_tenants\n}\n\nfragment TenantSelect_tenants on Query {\n  tenants: accountsEmployers(order: {name: ASC}, where: {name: {contains: ""}}) {\n    nodes {\n      id\n      name\n      entityId\n    }\n  }\n}\n'
  }
};
node16.hash = "78710f86527bf533b5dc7c1037f69f7a";
var TenantSelectContainerQuery_graphql_default = node16;

// src/tenants/components/TenantSelectContainer.tsx
import { useLazyLoadQuery as useLazyLoadQuery6 } from "react-relay";
import { jsx as jsx16 } from "react/jsx-runtime";
var queryDef6 = TenantSelectContainerQuery_graphql_default;
var TenantSelectContainer = ({
  label,
  placeHolder,
  tenant,
  onSelected
}) => {
  const query = useLazyLoadQuery6(
    queryDef6,
    {},
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx16(
    TenantSelect,
    {
      queryRef: query,
      label,
      placeHolder: placeHolder ? placeHolder : `Search Employers`,
      tenant,
      onSelected
    }
  );
};

// src/email-templates/components/EmailTemplateSelector.tsx
import { jsx as jsx17, jsxs as jsxs14 } from "react/jsx-runtime";
var EmailTemplateSelector = ({
  initialEmployer,
  onEmployerChanged,
  onTenantChanged,
  onNotificationTypeChanged
}) => {
  const [employer, setEmployer] = useState7(initialEmployer);
  const [tenant, setTenant] = useState7(AnyTenant);
  const [notificationType, setNotificationType] = useState7(AnyNotificationType);
  function changeEmployer(id) {
    setEmployer(id);
    onEmployerChanged(id);
  }
  function changeTenant(data) {
    setTenant(data);
    onTenantChanged(data);
  }
  function changeNotificationType(data) {
    setNotificationType(data);
    onNotificationTypeChanged(data);
  }
  return /* @__PURE__ */ jsxs14("div", { className: "flex flex-col gap-5 pb-5", children: [
    /* @__PURE__ */ jsxs14("div", { className: "flex flex-col gap-2 pt-3", children: [
      /* @__PURE__ */ jsx17("div", { className: "block text-sm font-medium text-gray-700", children: "Select Global or an Employer" }),
      /* @__PURE__ */ jsxs14("div", { className: "flex flex-row gap-2", children: [
        /* @__PURE__ */ jsx17(
          Button5,
          {
            onClick: () => {
              changeEmployer("global");
              changeTenant(AnyTenant);
            },
            color: employer == "global" ? "primary" : void 0,
            children: "Global"
          }
        ),
        /* @__PURE__ */ jsx17(
          Button5,
          {
            onClick: () => changeEmployer("employer"),
            color: employer == "employer" ? "primary" : void 0,
            children: "Employer"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx17("div", { className: "relative z-10", children: /* @__PURE__ */ jsx17(Suspense7, { fallback: "Loading...", children: employer === "employer" && /* @__PURE__ */ jsx17(
      TenantSelectContainer,
      {
        label: `Employer`,
        tenant,
        placeHolder: `Search Employers`,
        onSelected: (e) => {
          changeTenant(e);
        }
      }
    ) }) }),
    /* @__PURE__ */ jsx17("div", { className: "z-5 relative", children: /* @__PURE__ */ jsx17(
      NotificationTypesSelect,
      {
        notificationType,
        label: "Notification Type",
        onSelected: (e) => {
          changeNotificationType(e);
        }
      }
    ) })
  ] });
};

// src/email-templates/components/__generated__/EmailTemplatesListPaginationQuery.graphql.ts
var node17 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailTemplatesListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "EmailTemplatesList_templates"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailTemplatesListPaginationQuery",
      "selections": [
        {
          "alias": "templates",
          "args": v3,
          "concreteType": "NotificationsEmailNotificationTemplatesConnection",
          "kind": "LinkedField",
          "name": "notificationsEmailNotificationTemplates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationsEmailNotificationTemplatesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EmailNotificationTemplate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailNotificationTemplateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "notificationType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "renderingEngine",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "templateType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tenant",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "templates",
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "EmailTemplatesList_templates",
          "kind": "LinkedHandle",
          "name": "notificationsEmailNotificationTemplates"
        }
      ]
    },
    "params": {
      "cacheID": "11d566b11fe224e8a00928e9d907bc80",
      "id": null,
      "metadata": {},
      "name": "EmailTemplatesListPaginationQuery",
      "operationKind": "query",
      "text": "query EmailTemplatesListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $order: [EmailNotificationTemplateSort!]\n  $where: EmailNotificationTemplateFilter\n) {\n  ...EmailTemplatesList_templates_2HEEH6\n}\n\nfragment EmailTemplateRow_template on EmailNotificationTemplate {\n  id\n  emailNotificationTemplateId\n  createdAt\n  updatedAt\n  name\n  contentType\n  notificationType\n  renderingEngine\n  templateType\n  version\n  tenant\n}\n\nfragment EmailTemplatesList_templates_2HEEH6 on Query {\n  templates: notificationsEmailNotificationTemplates(first: $first, after: $after, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        emailNotificationTemplateId\n        ...EmailTemplateRow_template\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node17.hash = "7b0e0e1b8dc18e9b7e863446ed8bb9bf";
var EmailTemplatesListPaginationQuery_graphql_default = node17;

// src/email-templates/components/__generated__/EmailTemplatesList_templates.graphql.ts
var node18 = function() {
  var v0 = [
    "templates"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "order"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmailTemplatesListPaginationQuery_graphql_default
      }
    },
    "name": "EmailTemplatesList_templates",
    "selections": [
      {
        "alias": "templates",
        "args": null,
        "concreteType": "NotificationsEmailNotificationTemplatesConnection",
        "kind": "LinkedField",
        "name": "__EmailTemplatesList_templates_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationsEmailNotificationTemplatesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EmailNotificationTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailNotificationTemplateId",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EmailTemplateRow_template"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node18.hash = "7b0e0e1b8dc18e9b7e863446ed8bb9bf";
var EmailTemplatesList_templates_graphql_default = node18;

// src/email-templates/components/EmailTemplatesList.tsx
import { useCallback as useCallback7 } from "react";
import { usePaginationFragment } from "react-relay";
import { isNotNullOrUndefined as isNotNullOrUndefined2 } from "shared-lib";
import {
  EdListHeader,
  EdTable as EdTable4,
  selectColumn,
  SortDir as SortDir2
} from "shared-ui";
import { jsx as jsx18, jsxs as jsxs15 } from "react/jsx-runtime";
var defaultColumns = [
  { id: "title", name: "Title" },
  { id: "type", name: "Type" },
  { id: "employer", name: "Employer" },
  { id: "dateAdded", name: "Date Added", sort: true },
  {
    id: "updatedOn",
    name: "Last Update",
    sort: true,
    sortValue: SortDir2.Desc
  },
  { id: "notificationType", name: "Notification Type" },
  { id: "syntax", name: "Syntax" },
  { id: "contentType", name: "Content Type" }
];
var fragment = EmailTemplatesList_templates_graphql_default;
var EmailTemplatesList = ({
  onSelect,
  templatesKey,
  tenantName
}) => {
  const rowSelected = useCallback7(
    (e) => {
      onSelect({
        id: e.emailNotificationTemplateId,
        name: e.name,
        tenant: e.tenant,
        notificationType: e.notificationType,
        templateType: e.templateType
      });
    },
    [onSelect]
  );
  const paging = usePaginationFragment(fragment, templatesKey);
  const { data, refetch } = paging;
  const onSortChanged = useCallback7(
    (columns) => {
      const hasOrderBy = columns.filter((c) => c.sort && c.sortValue).length > 0;
      if (hasOrderBy === false) {
        return;
      }
      const orderBy = [];
      const createdAt = selectColumn("createdAt", columns);
      if (createdAt) {
        orderBy.push({ createdAt });
      }
      const updatedAt = selectColumn("updatedAt", columns);
      if (updatedAt) {
        orderBy.push({ updatedAt });
      }
      refetch(
        { first: 10, order: orderBy },
        {
          fetchPolicy: "network-only",
          onComplete: (e) => {
            if (e) {
              console.error(e);
            } else {
              console.log("changed sort on job order list");
            }
          }
        }
      );
    },
    [refetch]
  );
  const rows = (data.templates?.edges || []).map((e) => e.node).filter(isNotNullOrUndefined2).map((e) => {
    return /* @__PURE__ */ jsx18(
      EmailTemplateRow,
      {
        fragmentRef: e,
        onSelect: rowSelected,
        tenantName
      },
      e.emailNotificationTemplateId
    );
  });
  return /* @__PURE__ */ jsxs15("div", { className: "flex flex-col overflow-hidden", children: [
    /* @__PURE__ */ jsx18(EdListHeader, { total: data.templates?.totalCount, paging }),
    /* @__PURE__ */ jsx18("div", { className: "flex ", children: /* @__PURE__ */ jsx18("div", { className: "w-full", children: /* @__PURE__ */ jsx18(
      EdTable4,
      {
        defaultColumns,
        rows,
        onSortChanged
      }
    ) }) })
  ] });
};

// src/email-templates/components/__generated__/EmailTemplatesListContainerQuery.graphql.ts
var node19 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmailTemplatesListContainerQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmailTemplatesList_templates"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmailTemplatesListContainerQuery",
      "selections": [
        {
          "alias": "templates",
          "args": v1,
          "concreteType": "NotificationsEmailNotificationTemplatesConnection",
          "kind": "LinkedField",
          "name": "notificationsEmailNotificationTemplates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationsEmailNotificationTemplatesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EmailNotificationTemplate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailNotificationTemplateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "notificationType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "renderingEngine",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "templateType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tenant",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "templates",
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "EmailTemplatesList_templates",
          "kind": "LinkedHandle",
          "name": "notificationsEmailNotificationTemplates"
        }
      ]
    },
    "params": {
      "cacheID": "6cdc0814bda94344061800d5bf713485",
      "id": null,
      "metadata": {},
      "name": "EmailTemplatesListContainerQuery",
      "operationKind": "query",
      "text": "query EmailTemplatesListContainerQuery(\n  $order: [EmailNotificationTemplateSort!]!\n  $where: EmailNotificationTemplateFilter!\n) {\n  ...EmailTemplatesList_templates\n}\n\nfragment EmailTemplateRow_template on EmailNotificationTemplate {\n  id\n  emailNotificationTemplateId\n  createdAt\n  updatedAt\n  name\n  contentType\n  notificationType\n  renderingEngine\n  templateType\n  version\n  tenant\n}\n\nfragment EmailTemplatesList_templates on Query {\n  templates: notificationsEmailNotificationTemplates(first: 10, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        emailNotificationTemplateId\n        ...EmailTemplateRow_template\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node19.hash = "d717c48a0df3a522506a09b75942e573";
var EmailTemplatesListContainerQuery_graphql_default = node19;

// src/email-templates/components/EmailTemplatesListContainer.tsx
import { Suspense as Suspense8, useState as useState10 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery7 } from "react-relay";
import { useLocalStorage as useLocalStorage2 } from "usehooks-ts";
import { Input as Input2, Loading as Loading2 } from "shared-ui";
import { isNotNullOrUndefinedOrEmpty, useDebounce as useDebounce3 } from "shared-lib";

// src/email-templates/components/EmailTemplateTypesSelect.tsx
import { useState as useState8 } from "react";
import { Combobox as Combobox3, Transition as Transition3 } from "@headlessui/react";
import { CheckIcon as CheckIcon3, ChevronUpDownIcon as ChevronUpDownIcon3 } from "@heroicons/react/20/solid";
import { Fragment as Fragment6, jsx as jsx19, jsxs as jsxs16 } from "react/jsx-runtime";
var editableEmailTemplateTypes = [
  { id: "SUBJECT", name: "Subject" },
  { id: "BODY_TEXT", name: "Body Text" },
  { id: "BODY_HTML", name: "Body Html" }
];
var emailTemplateTypes = [
  { id: null, name: "Any" },
  { id: "SUBJECT", name: "Subject" },
  { id: "BODY_TEXT", name: "Body Text" },
  { id: "BODY_HTML", name: "Body Html" }
  // { id: 'BODY_AMP', name: 'Body AMP' },
  // { id: 'UNKNOWN', name: 'Unknown' },
];
function SelectBox({
  selected,
  onSelected,
  label,
  types
}) {
  const [query, setQuery] = useState8("");
  const filtered = query === "" ? types : types.filter(
    (e) => e?.name.toLowerCase().replace(/\s+/g, "").includes(query.toLowerCase().replace(/\s+/g, ""))
  );
  return /* @__PURE__ */ jsxs16("div", { className: "", children: [
    label && /* @__PURE__ */ jsx19("label", { className: "block text-sm font-medium text-gray-700", children: label }),
    /* @__PURE__ */ jsx19(Combobox3, { value: selected, onChange: onSelected, children: /* @__PURE__ */ jsxs16("div", { className: "relative mt-1", children: [
      /* @__PURE__ */ jsxs16("div", { className: "relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm", children: [
        /* @__PURE__ */ jsx19(
          Combobox3.Input,
          {
            className: "w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0",
            displayValue: (e) => e?.name,
            onChange: (event) => setQuery(event.target.value)
          }
        ),
        /* @__PURE__ */ jsx19(Combobox3.Button, { className: "absolute inset-y-0 right-0 flex items-center pr-2", children: /* @__PURE__ */ jsx19(
          ChevronUpDownIcon3,
          {
            className: "h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx19(
        Transition3,
        {
          as: "div",
          leave: "transition ease-in duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          afterLeave: () => setQuery(""),
          children: /* @__PURE__ */ jsx19(Combobox3.Options, { className: "absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: filtered.length === 0 && query !== "" ? /* @__PURE__ */ jsx19("div", { className: "relative cursor-default select-none px-4 py-2 text-gray-700", children: "Nothing found." }) : filtered.map((e, i) => /* @__PURE__ */ jsx19(
            Combobox3.Option,
            {
              className: ({ active }) => `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? "bg-info-600 text-white" : "text-gray-900"}`,
              value: e,
              children: ({ selected: selected2, active }) => /* @__PURE__ */ jsxs16(Fragment6, { children: [
                /* @__PURE__ */ jsx19(
                  "span",
                  {
                    className: `block truncate ${selected2 ? "font-medium" : "font-normal"}`,
                    children: e?.name
                  }
                ),
                selected2 ? /* @__PURE__ */ jsx19(
                  "span",
                  {
                    className: `bg-info-500 absolute inset-y-0 left-0 flex items-center pl-3 ${active ? "text-white" : "text-teal-600"}`,
                    children: /* @__PURE__ */ jsx19(CheckIcon3, { className: "h-5 w-5", "aria-hidden": "true" })
                  }
                ) : null
              ] })
            },
            i
          )) })
        }
      )
    ] }) })
  ] });
}
var EmailTemplateTypesSelect = SelectBox;

// src/email-templates/components/RenderingEngineTypeSelect.tsx
import { useState as useState9 } from "react";
import { Combobox as Combobox4, Transition as Transition4 } from "@headlessui/react";
import { CheckIcon as CheckIcon4, ChevronUpDownIcon as ChevronUpDownIcon4 } from "@heroicons/react/20/solid";
import { Fragment as Fragment7, jsx as jsx20, jsxs as jsxs17 } from "react/jsx-runtime";
var RenderingEngineTypes = [
  { id: "", name: "Any" },
  { id: "RAZOR", name: "Razor" },
  { id: "SCRIBAN", name: "Scriban" }
];
var RenderingEngineTypesSelect = ({
  selected,
  onSelected,
  label,
  showAny
}) => {
  const showAnyFilter = (() => {
    if (showAny !== false) {
      return () => true;
    } else {
      return (x) => x.id !== "";
    }
  })();
  const [query, setQuery] = useState9("");
  const filtered = query === "" ? RenderingEngineTypes.filter(showAnyFilter) : RenderingEngineTypes.filter(
    (e) => e?.name.toLowerCase().replace(/\s+/g, "").includes(query.toLowerCase().replace(/\s+/g, ""))
  );
  return /* @__PURE__ */ jsxs17("div", { className: "", children: [
    label && /* @__PURE__ */ jsx20("label", { className: "block text-sm font-medium text-gray-700", children: label }),
    /* @__PURE__ */ jsx20(Combobox4, { value: selected, onChange: onSelected, children: /* @__PURE__ */ jsxs17("div", { className: "relative mt-1", children: [
      /* @__PURE__ */ jsxs17("div", { className: "relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm", children: [
        /* @__PURE__ */ jsx20(
          Combobox4.Input,
          {
            className: "w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0",
            displayValue: (e) => e?.name,
            onChange: (event) => setQuery(event.target.value)
          }
        ),
        /* @__PURE__ */ jsx20(Combobox4.Button, { className: "absolute inset-y-0 right-0 flex items-center pr-2", children: /* @__PURE__ */ jsx20(
          ChevronUpDownIcon4,
          {
            className: "h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx20(
        Transition4,
        {
          as: "div",
          leave: "transition ease-in duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          afterLeave: () => setQuery(""),
          children: /* @__PURE__ */ jsx20(Combobox4.Options, { className: "absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm", children: filtered.length === 0 && query !== "" ? /* @__PURE__ */ jsx20("div", { className: "relative cursor-default select-none px-4 py-2 text-gray-700", children: "Nothing found." }) : filtered.map((e) => /* @__PURE__ */ jsx20(
            Combobox4.Option,
            {
              className: ({ active }) => `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? "bg-info-600 text-white" : "text-gray-900"}`,
              value: e,
              children: ({ selected: selected2, active }) => /* @__PURE__ */ jsxs17(Fragment7, { children: [
                /* @__PURE__ */ jsx20(
                  "span",
                  {
                    className: `block truncate ${selected2 ? "font-medium" : "font-normal"}`,
                    children: e?.name
                  }
                ),
                selected2 ? /* @__PURE__ */ jsx20(
                  "span",
                  {
                    className: `bg-info-500 absolute inset-y-0 left-0 flex items-center pl-3 ${active ? "text-white" : "text-teal-600"}`,
                    children: /* @__PURE__ */ jsx20(CheckIcon4, { className: "h-5 w-5", "aria-hidden": "true" })
                  }
                ) : null
              ] })
            },
            e.id
          )) })
        }
      )
    ] }) })
  ] });
};

// src/email-templates/components/EmailTemplatesListContainer.tsx
import { jsx as jsx21, jsxs as jsxs18 } from "react/jsx-runtime";
var queryDef7 = EmailTemplatesListContainerQuery_graphql_default;
var EmailTemplatesListContainer = ({
  onSelect
}) => {
  const [filter, setFilter] = useLocalStorage2(
    "emailTemplatesSearchFilter",
    ""
  );
  const [templateTypeSelected, setTemplateTypeSelected] = useLocalStorage2("emailTemplatesTemplateTypeFilter", { id: null, name: "Any" });
  const [notificationTypeSelected, setNotificationTypeSelected] = useLocalStorage2(
    "emailTemplatesNotificationTypeFilter",
    null
  );
  const [selectedTenant, onSelectTenant] = useLocalStorage2(
    "emailTemplatesTenantFilter",
    AnyTenant
  );
  const [selectedRenderingEngine, onSelectRenderingEngine] = useState10({
    id: null,
    name: "Any"
  });
  const searchTerm = useDebounce3(filter, 500);
  const order = [{ updatedAt: "DESC" }];
  const where = {};
  let and = [];
  if (searchTerm && filter) {
    and = [...and, { name: { startsWith: filter } }];
  }
  if (templateTypeSelected && templateTypeSelected.id !== null) {
    and = [...and, { templateType: { eq: templateTypeSelected.id || "" } }];
  }
  if (notificationTypeSelected && notificationTypeSelected?.notificationType?.key !== void 0) {
    and = [
      ...and,
      {
        notificationType: {
          eq: notificationTypeSelected?.notificationType?.key
        }
      }
    ];
  }
  if (selectedTenant && selectedTenant.entityId !== null) {
    and = [...and, { tenant: { eq: selectedTenant.entityId } }];
  } else {
    and = [...and, { tenant: { eq: "00000000-0000-0000-0000-000000000000" } }];
  }
  if (selectedRenderingEngine && isNotNullOrUndefinedOrEmpty(selectedRenderingEngine.id)) {
    and = [...and, { renderingEngine: { eq: selectedRenderingEngine.id } }];
  }
  if (and.length > 0) {
    where.and = and;
  }
  const query = useLazyLoadQuery7(
    queryDef7,
    { where, order },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx21(Suspense8, { fallback: /* @__PURE__ */ jsx21(Loading2, { label: "Loading Notifications" }), children: /* @__PURE__ */ jsxs18("div", { className: "", children: [
    /* @__PURE__ */ jsx21("div", { className: "flex flex-grow items-center justify-between space-x-4", children: /* @__PURE__ */ jsxs18("div", { className: "flex flex-grow flex-col items-center justify-between space-x-4 lg:flex-row", children: [
      /* @__PURE__ */ jsx21("div", { className: "flex w-full items-center justify-between space-x-4 p-2", children: /* @__PURE__ */ jsx21("div", { className: "w-full", children: /* @__PURE__ */ jsx21(
        Input2,
        {
          placeholder: "Search Title or Code ",
          name: "filter",
          value: filter,
          onValueChange: (filter2) => setFilter(filter2)
        },
        "filter"
      ) }) }),
      /* @__PURE__ */ jsxs18("div", { className: "flex w-full items-center justify-between space-x-4 p-2", children: [
        /* @__PURE__ */ jsx21("label", { className: "text-gray-700", htmlFor: "filter", children: "Type" }),
        /* @__PURE__ */ jsx21("div", { className: "w-full", children: /* @__PURE__ */ jsx21(
          EmailTemplateTypesSelect,
          {
            selected: templateTypeSelected,
            onSelected: setTemplateTypeSelected,
            types: emailTemplateTypes
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs18("div", { className: "flex w-full items-center justify-between space-x-4 p-2", children: [
        /* @__PURE__ */ jsx21("label", { className: "text-gray-700", htmlFor: "filter", children: "Notification" }),
        /* @__PURE__ */ jsx21("div", { className: "w-full", children: /* @__PURE__ */ jsx21(
          NotificationTypesSelect,
          {
            notificationType: AnyNotificationType,
            onSelected: (e) => {
              setNotificationTypeSelected(e);
            }
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs18("div", { className: "flex w-full items-center justify-between space-x-4 p-2", children: [
        /* @__PURE__ */ jsx21("label", { className: "text-gray-700", htmlFor: "filter", children: "Employer" }),
        /* @__PURE__ */ jsx21("div", { className: "w-full", children: /* @__PURE__ */ jsx21(Suspense8, { fallback: "Loading...", children: /* @__PURE__ */ jsx21(
          TenantSelectContainer,
          {
            tenant: selectedTenant,
            onSelected: onSelectTenant
          },
          "tenant-select"
        ) }) })
      ] }),
      /* @__PURE__ */ jsxs18("div", { className: "flex w-full items-center justify-between space-x-4 p-2", children: [
        /* @__PURE__ */ jsx21("label", { className: "text-gray-700", htmlFor: "filter", children: "Engine" }),
        /* @__PURE__ */ jsx21("div", { className: "w-full", children: /* @__PURE__ */ jsx21(Suspense8, { fallback: "Loading...", children: /* @__PURE__ */ jsx21(
          RenderingEngineTypesSelect,
          {
            selected: selectedRenderingEngine,
            onSelected: onSelectRenderingEngine
          }
        ) }) })
      ] })
    ] }) }),
    selectedTenant ? /* @__PURE__ */ jsx21(
      EmailTemplatesList,
      {
        onSelect,
        templatesKey: query,
        tenantName: selectedTenant.name
      }
    ) : /* @__PURE__ */ jsx21("p", { children: "Select Tenant" })
  ] }) });
};

// src/email-templates/components/__generated__/EmailTemplatesTable_templates.graphql.ts
var node20 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmailTemplatesTable_templates",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NotificationsEmailNotificationTemplatesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailNotificationTemplate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailNotificationTemplateId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tenant",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notificationType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "templateType",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmailTemplateRow_template"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NotificationsEmailNotificationTemplatesConnection",
  "abstractKey": null
};
node20.hash = "5d92089c4b2d9e8434bc4971f6e91616";
var EmailTemplatesTable_templates_graphql_default = node20;

// src/email-templates/components/EmailTemplatesTable.tsx
import { useFragment as useFragment6 } from "react-relay";
import { EdTable as EdTable5 } from "shared-ui";
import { Fragment as Fragment8, jsx as jsx22 } from "react/jsx-runtime";
var fragmentDef6 = EmailTemplatesTable_templates_graphql_default;
var EmailTemplatesTable = ({
  fragmentRef,
  tenantName,
  onSelect
}) => {
  const data = useFragment6(
    fragmentDef6,
    fragmentRef
  );
  const nodes = data?.edges?.map((e) => e.node) || [];
  const rows = nodes.map((row) => {
    if (!row)
      return /* @__PURE__ */ jsx22(Fragment8, {});
    return /* @__PURE__ */ jsx22(
      EmailTemplateRow,
      {
        fragmentRef: row,
        tenantName,
        onSelect: (e) => {
          onSelect({
            tenant: e.tenant,
            notificationType: e.notificationType,
            templateType: e.templateType
          });
        }
      },
      row.emailNotificationTemplateId
    );
  });
  return /* @__PURE__ */ jsx22(EdTable5, { rows, defaultColumns: EmailTemplateRowColumns });
};

// src/email-templates/components/EmailTemplateTypeCreateList.tsx
import { jsx as jsx23 } from "react/jsx-runtime";
var EmailTemplateTypeCreateList = ({
  tenantId,
  notificationTypeKey,
  existingNotificationTypes,
  onCreated,
  onFail
}) => {
  return /* @__PURE__ */ jsx23("div", { className: "mt-2 flex flex-col gap-2", children: editableEmailTemplateTypes.filter(({ id }) => {
    return !existingNotificationTypes.includes(id);
  }).map((x, i) => /* @__PURE__ */ jsx23(
    EmailTemplateCreateButton,
    {
      tenantId,
      notificationTypeKey,
      templateType: x.id,
      onCreateSucceeded: onCreated,
      onCreateFail: onFail
    },
    i
  )) });
};

// src/email-templates/components/__generated__/NotificationTemplatesContainerQuery.graphql.ts
var node21 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "notificationType"
    },
    {
      "defaultValue": "BODY_HTML",
      "kind": "LocalArgument",
      "name": "templateType"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenant"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "NotificationTemplatesContainerQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "notificationType",
              "variableName": "notificationType"
            },
            {
              "kind": "Variable",
              "name": "templateType",
              "variableName": "templateType"
            },
            {
              "kind": "Variable",
              "name": "tenant",
              "variableName": "tenant"
            }
          ],
          "kind": "FragmentSpread",
          "name": "NotificationTemplatesContainer_Query"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "NotificationTemplatesContainerQuery",
      "selections": [
        {
          "alias": "notifications",
          "args": [
            {
              "fields": [
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "eq",
                      "variableName": "notificationType"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "notificationType"
                },
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "eq",
                      "variableName": "templateType"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "templateType"
                },
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "eq",
                      "variableName": "tenant"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "tenant"
                }
              ],
              "kind": "ObjectValue",
              "name": "where"
            }
          ],
          "concreteType": "NotificationsEmailNotificationTemplatesConnection",
          "kind": "LinkedField",
          "name": "notificationsEmailNotificationTemplates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EmailNotificationTemplate",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v1,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailNotificationTemplateId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "version",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tenant",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "content",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "templateType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "notificationType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contentType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "renderingEngine",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EmailNotificationDefinition",
                  "kind": "LinkedField",
                  "name": "notificationDefinition",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "example",
                      "storageKey": null
                    },
                    v1
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "df0fecbd8b1686e2606ca3230a42d548",
      "id": null,
      "metadata": {},
      "name": "NotificationTemplatesContainerQuery",
      "operationKind": "query",
      "text": "query NotificationTemplatesContainerQuery(\n  $notificationType: String\n  $templateType: EmailTemplateType = BODY_HTML\n  $tenant: UUID\n) {\n  ...NotificationTemplatesContainer_Query_2G42xk\n}\n\nfragment EmailTemplateContainer_template on EmailNotificationTemplate {\n  id\n  emailNotificationTemplateId\n  version\n  createdAt\n  updatedAt\n  tenant\n  name\n  content\n  templateType\n  notificationType\n  contentType\n  renderingEngine\n  notificationDefinition {\n    example\n    id\n  }\n}\n\nfragment NotificationTemplatesContainer_Query_2G42xk on Query {\n  notifications: notificationsEmailNotificationTemplates(where: {tenant: {eq: $tenant}, notificationType: {eq: $notificationType}, templateType: {eq: $templateType}}) {\n    ...NotificationTemplatesList_templates\n  }\n}\n\nfragment NotificationTemplatesList_templates on NotificationsEmailNotificationTemplatesConnection {\n  nodes {\n    ...EmailTemplateContainer_template\n    id\n  }\n}\n"
    }
  };
}();
node21.hash = "cc0d8b712566e1e064afe61189b10f18";
var NotificationTemplatesContainerQuery_graphql_default = node21;

// src/email-templates/components/__generated__/NotificationTemplatesContainer_Query.graphql.ts
var node22 = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "notificationType"
    },
    {
      "defaultValue": "BODY_HTML",
      "kind": "LocalArgument",
      "name": "templateType"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenant"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": NotificationTemplatesContainerQuery_graphql_default
    }
  },
  "name": "NotificationTemplatesContainer_Query",
  "selections": [
    {
      "alias": "notifications",
      "args": [
        {
          "fields": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "eq",
                  "variableName": "notificationType"
                }
              ],
              "kind": "ObjectValue",
              "name": "notificationType"
            },
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "eq",
                  "variableName": "templateType"
                }
              ],
              "kind": "ObjectValue",
              "name": "templateType"
            },
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "eq",
                  "variableName": "tenant"
                }
              ],
              "kind": "ObjectValue",
              "name": "tenant"
            }
          ],
          "kind": "ObjectValue",
          "name": "where"
        }
      ],
      "concreteType": "NotificationsEmailNotificationTemplatesConnection",
      "kind": "LinkedField",
      "name": "notificationsEmailNotificationTemplates",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NotificationTemplatesList_templates"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
node22.hash = "cc0d8b712566e1e064afe61189b10f18";
var NotificationTemplatesContainer_Query_graphql_default = node22;

// src/email-templates/components/NotificationTemplatesContainer.tsx
import { useEffect as useEffect5 } from "react";
import { useRefetchableFragment as useRefetchableFragment2 } from "react-relay";

// src/email-templates/components/__generated__/NotificationTemplatesList_templates.graphql.ts
var node23 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationTemplatesList_templates",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailNotificationTemplate",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmailTemplateContainer_template"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NotificationsEmailNotificationTemplatesConnection",
  "abstractKey": null
};
node23.hash = "8361e10c7b39f0b828ccef6a906a8ab2";
var NotificationTemplatesList_templates_graphql_default = node23;

// src/email-templates/components/NotificationTemplatesList.tsx
import { useFragment as useFragment7 } from "react-relay";
import { useNavigate } from "react-router-dom";
import { isNotNull } from "shared-lib";
import { jsx as jsx24, jsxs as jsxs19 } from "react/jsx-runtime";
var fragmentDef7 = NotificationTemplatesList_templates_graphql_default;
var NotificationTemplatesList = ({
  id,
  tenant,
  type,
  fragmentRef,
  onSetExampleJson
}) => {
  const navigate = useNavigate();
  const data = useFragment7(
    fragmentDef7,
    fragmentRef
  );
  if (data?.nodes == null || data.nodes.length == 0) {
    return /* @__PURE__ */ jsxs19("div", { className: "flex items-baseline gap-2", children: [
      /* @__PURE__ */ jsx24("div", { children: "Layout does not exist" }),
      /* @__PURE__ */ jsx24(
        EmailTemplateCreateButton,
        {
          tenantId: tenant,
          notificationTypeKey: id,
          templateType: type,
          onCreateSucceeded: () => {
            navigate(0);
          },
          onCreateFail: (error) => {
            alert(error);
          }
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsx24("div", { children: (data.nodes || []).filter(isNotNull).map((x, key) => {
    return /* @__PURE__ */ jsx24(
      EmailTemplateContainer,
      {
        onSetExampleJson,
        fragmentRef: x
      },
      key
    );
  }) });
};

// src/email-templates/components/NotificationTemplatesContainer.tsx
import { jsx as jsx25 } from "react/jsx-runtime";
var fragmentDef8 = NotificationTemplatesContainer_Query_graphql_default;
var NotificationTemplatesContainer = ({
  id,
  tenant,
  templateType,
  onSetExampleJson,
  fragmentRef
}) => {
  const [data, refetch] = useRefetchableFragment2(fragmentDef8, fragmentRef);
  useEffect5(() => {
    refetch({
      templateType
    });
  }, [templateType, refetch, tenant]);
  if (data.notifications == null) {
    return /* @__PURE__ */ jsx25("div", { children: "No Notifications" });
  }
  return /* @__PURE__ */ jsx25(
    NotificationTemplatesList,
    {
      id,
      tenant,
      type: templateType,
      onSetExampleJson,
      fragmentRef: data.notifications
    }
  );
};

// src/email-templates/components/NotificationTypeNav.tsx
import { useState as useState11 } from "react";
import { NavigationLink as NavigationLink2, Button as Button6 } from "shared-ui";
import { jsx as jsx26, jsxs as jsxs20 } from "react/jsx-runtime";
var NotificationTypeNav = ({
  id,
  tenant,
  type,
  onChangeShowVariables
}) => {
  const [templateType, setTemplateType] = useState11(
    type || "BODY_HTML"
  );
  const [showVariables, setShowVariables] = useState11(false);
  function changeTemplateType(templateType2) {
    setTemplateType(templateType2);
  }
  function changeShowVariables(show) {
    setShowVariables(show);
    onChangeShowVariables(show);
  }
  return /* @__PURE__ */ jsxs20("nav", { className: "flex w-full flex-row justify-between", children: [
    /* @__PURE__ */ jsxs20("div", { className: "flex", children: [
      /* @__PURE__ */ jsx26(
        NavigationLink2,
        {
          onClick: () => changeTemplateType("BODY_HTML"),
          active: templateType == "BODY_HTML",
          to: `../template/${tenant}/${id}/BODY_HTML`,
          children: "Html"
        }
      ),
      /* @__PURE__ */ jsx26(
        NavigationLink2,
        {
          onClick: () => changeTemplateType("SUBJECT"),
          active: templateType == "SUBJECT",
          to: `../template/${tenant}/${id}/SUBJECT`,
          children: "Subject"
        }
      ),
      /* @__PURE__ */ jsx26(
        NavigationLink2,
        {
          onClick: () => changeTemplateType("BODY_TEXT"),
          active: templateType == "BODY_TEXT",
          to: `../template/${tenant}/${id}/BODY_TEXT`,
          children: "Text"
        }
      )
    ] }),
    /* @__PURE__ */ jsx26("div", { className: "flex items-center pr-5", children: /* @__PURE__ */ jsxs20(
      Button6,
      {
        color: "primary",
        onClick: () => changeShowVariables(!showVariables),
        children: [
          showVariables ? "Hide" : "Show",
          " Variables"
        ]
      }
    ) })
  ] });
};

// src/email-templates/components/__generated__/NotificationTypeTemplatesListQuery.graphql.ts
var node24 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "notificationType"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tenant"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "order",
      "value": {
        "name": "ASC"
      }
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "notificationType"
            }
          ],
          "kind": "ObjectValue",
          "name": "notificationType"
        },
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "tenant"
            }
          ],
          "kind": "ObjectValue",
          "name": "tenant"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "templateType",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EmailNotificationTemplate",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      v3,
      v4
    ],
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "NotificationTypeTemplatesListQuery",
      "selections": [
        {
          "alias": "notifications",
          "args": v2,
          "concreteType": "NotificationsEmailNotificationTemplatesConnection",
          "kind": "LinkedField",
          "name": "notificationsEmailNotificationTemplates",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EmailTemplatesTable_templates"
            },
            v5
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "NotificationTypeTemplatesListQuery",
      "selections": [
        {
          "alias": "notifications",
          "args": v2,
          "concreteType": "NotificationsEmailNotificationTemplatesConnection",
          "kind": "LinkedField",
          "name": "notificationsEmailNotificationTemplates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationsEmailNotificationTemplatesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EmailNotificationTemplate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v3,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "emailNotificationTemplateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tenant",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "notificationType",
                      "storageKey": null
                    },
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "renderingEngine",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v5
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "aad2bf420221299a7e6e784d968a56f5",
      "id": null,
      "metadata": {},
      "name": "NotificationTypeTemplatesListQuery",
      "operationKind": "query",
      "text": "query NotificationTypeTemplatesListQuery(\n  $tenant: UUID!\n  $notificationType: String!\n) {\n  notifications: notificationsEmailNotificationTemplates(where: {tenant: {eq: $tenant}, notificationType: {eq: $notificationType}}, order: {name: ASC}) {\n    ...EmailTemplatesTable_templates\n    nodes {\n      id\n      templateType\n    }\n  }\n}\n\nfragment EmailTemplateRow_template on EmailNotificationTemplate {\n  id\n  emailNotificationTemplateId\n  createdAt\n  updatedAt\n  name\n  contentType\n  notificationType\n  renderingEngine\n  templateType\n  version\n  tenant\n}\n\nfragment EmailTemplatesTable_templates on NotificationsEmailNotificationTemplatesConnection {\n  edges {\n    node {\n      id\n      emailNotificationTemplateId\n      tenant\n      notificationType\n      templateType\n      ...EmailTemplateRow_template\n    }\n  }\n}\n"
    }
  };
}();
node24.hash = "1e2b1ac14b47dee114b7387bc0a573ad";
var NotificationTypeTemplatesListQuery_graphql_default = node24;

// src/email-templates/components/NotificationTypeTemplatesList.tsx
import { useLazyLoadQuery as useLazyLoadQuery8 } from "react-relay";
import { Fragment as Fragment9, jsx as jsx27, jsxs as jsxs21 } from "react/jsx-runtime";
var queryDef8 = NotificationTypeTemplatesListQuery_graphql_default;
var NotificationTypeTemplatesList = ({
  tenantId,
  tenantName,
  notificationTypeKey,
  onSelect,
  onCreateSucceeded,
  onCreateFail
}) => {
  const data = useLazyLoadQuery8(
    queryDef8,
    {
      tenant: tenantId,
      notificationType: notificationTypeKey
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  if (data.notifications == null) {
    return /* @__PURE__ */ jsx27("div", { children: "No Notifications" });
  }
  const existingNotificationTypes = data?.notifications?.nodes?.map((p) => String(p?.templateType)) || [];
  return /* @__PURE__ */ jsxs21(Fragment9, { children: [
    /* @__PURE__ */ jsx27(
      EmailTemplatesTable,
      {
        tenantName,
        onSelect,
        fragmentRef: data.notifications
      }
    ),
    /* @__PURE__ */ jsx27(
      EmailTemplateTypeCreateList,
      {
        tenantId,
        notificationTypeKey,
        existingNotificationTypes,
        onCreated: onCreateSucceeded,
        onFail: onCreateFail
      }
    )
  ] });
};

// src/email-templates/NotificationCreateLayout.tsx
import { Suspense as Suspense9, useState as useState12 } from "react";
import { useNavigate as useNavigate2 } from "react-router-dom";
import { EdLink, MultiColumn, Spinner as Spinner4 } from "shared-ui";
import { jsx as jsx28, jsxs as jsxs22 } from "react/jsx-runtime";
var NotificationCreateLayout = () => {
  const [employer, setEmployer] = useState12("global");
  const [tenant, setTenant] = useState12(AnyTenant);
  const [notificationType, setNotificationType] = useState12(AnyNotificationType);
  const navigate = useNavigate2();
  const selectedTenantId = employer === "global" ? "00000000-0000-0000-0000-000000000000" : tenant.entityId;
  const selectedNotificationType = notificationType.emailNotificationDefinitionId;
  return /* @__PURE__ */ jsx28(
    MultiColumn,
    {
      mainContentHeader: /* @__PURE__ */ jsxs22("div", { className: "flex items-center space-x-2 border-b border-gray-200 pb-1 pt-3", children: [
        /* @__PURE__ */ jsx28(EdLink, { name: "back-link", href: `../`, children: /* @__PURE__ */ jsx28("div", { className: "text-info-500 hover:bg-info-100 cursor-pointer p-2", children: "Back" }) }),
        /* @__PURE__ */ jsx28("h2", { className: "text-info-700 text-xl font-medium", children: "Create Template" })
      ] }),
      mainContent: /* @__PURE__ */ jsxs22("div", { className: "container", children: [
        /* @__PURE__ */ jsx28(
          EmailTemplateSelector,
          {
            initialEmployer: employer,
            onEmployerChanged: setEmployer,
            onTenantChanged: setTenant,
            onNotificationTypeChanged: setNotificationType
          }
        ),
        /* @__PURE__ */ jsx28(Suspense9, { fallback: /* @__PURE__ */ jsx28(Spinner4, {}), children: selectedTenantId && selectedNotificationType && /* @__PURE__ */ jsx28(
          NotificationTypeTemplatesList,
          {
            tenantId: selectedTenantId,
            tenantName: employer,
            notificationTypeKey: selectedNotificationType,
            onSelect: ({ templateType, notificationType: notificationType2, tenant: tenant2 }) => {
              navigate(
                `../template/${tenant2}/${notificationType2}/${templateType}`
              );
            },
            onCreateSucceeded: (data) => {
              navigate(
                `../template/${data.tenant}/${data.notificationType}/${data.templateType}/editor`
              );
            },
            onCreateFail: (error) => {
              alert(error);
            }
          }
        ) })
      ] }),
      sideContent: void 0
    }
  );
};

// src/email-templates/__generated__/NotificationTypeLayoutQuery.graphql.ts
var node25 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "notificationType"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tenant"
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "NotificationTypeLayoutQuery",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "notificationType",
              "variableName": "notificationType"
            },
            {
              "kind": "Variable",
              "name": "tenant",
              "variableName": "tenant"
            }
          ],
          "kind": "FragmentSpread",
          "name": "NotificationTemplatesContainer_Query"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "NotificationTypeLayoutQuery",
      "selections": [
        {
          "alias": "notifications",
          "args": [
            {
              "fields": [
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "eq",
                      "variableName": "notificationType"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "notificationType"
                },
                {
                  "fields": [
                    {
                      "kind": "Literal",
                      "name": "eq",
                      "value": "BODY_HTML"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "templateType"
                },
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "eq",
                      "variableName": "tenant"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "tenant"
                }
              ],
              "kind": "ObjectValue",
              "name": "where"
            }
          ],
          "concreteType": "NotificationsEmailNotificationTemplatesConnection",
          "kind": "LinkedField",
          "name": "notificationsEmailNotificationTemplates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EmailNotificationTemplate",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                v2,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailNotificationTemplateId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "version",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tenant",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "content",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "templateType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "notificationType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contentType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "renderingEngine",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EmailNotificationDefinition",
                  "kind": "LinkedField",
                  "name": "notificationDefinition",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "example",
                      "storageKey": null
                    },
                    v2
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "09519d3f93ee584325fbdd24ba97502d",
      "id": null,
      "metadata": {},
      "name": "NotificationTypeLayoutQuery",
      "operationKind": "query",
      "text": "query NotificationTypeLayoutQuery(\n  $tenant: UUID\n  $notificationType: String\n) {\n  ...NotificationTemplatesContainer_Query_4v862A\n}\n\nfragment EmailTemplateContainer_template on EmailNotificationTemplate {\n  id\n  emailNotificationTemplateId\n  version\n  createdAt\n  updatedAt\n  tenant\n  name\n  content\n  templateType\n  notificationType\n  contentType\n  renderingEngine\n  notificationDefinition {\n    example\n    id\n  }\n}\n\nfragment NotificationTemplatesContainer_Query_4v862A on Query {\n  notifications: notificationsEmailNotificationTemplates(where: {tenant: {eq: $tenant}, notificationType: {eq: $notificationType}, templateType: {eq: BODY_HTML}}) {\n    ...NotificationTemplatesList_templates\n  }\n}\n\nfragment NotificationTemplatesList_templates on NotificationsEmailNotificationTemplatesConnection {\n  nodes {\n    ...EmailTemplateContainer_template\n    id\n  }\n}\n"
    }
  };
}();
node25.hash = "85fc5a6cbca0bf52090c2b5f543ec211";
var NotificationTypeLayoutQuery_graphql_default = node25;

// src/email-templates/NotificationTypeLayout.tsx
import { useState as useState13 } from "react";
import { useParams } from "react-router-dom";
import { useLazyLoadQuery as useLazyLoadQuery9 } from "react-relay";
import { MultiColumn as MultiColumn2, EdLink as EdLink2 } from "shared-ui";
import { Fragment as Fragment10, jsx as jsx29, jsxs as jsxs23 } from "react/jsx-runtime";
var NotificationTypeLayout = () => {
  const { id, tenant, type } = useParams();
  const [showVariables, setShowVariables] = useState13(false);
  const queryRef = useLazyLoadQuery9(
    NotificationTypeLayoutQuery_graphql_default,
    {
      tenant: tenant || "",
      notificationType: id || ""
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const [exampleJson, setExampleJson] = useState13("");
  if (!id || !tenant || !type) {
    return /* @__PURE__ */ jsx29("div", { children: /* @__PURE__ */ jsx29("h1", { children: "Invalid State. No Template Data Provided" }) });
  }
  return /* @__PURE__ */ jsxs23("div", { className: "w-full", children: [
    /* @__PURE__ */ jsx29("div", { className: "flex items-center border-b bg-white", children: /* @__PURE__ */ jsx29(EdLink2, { name: "back-link", href: `../`, children: /* @__PURE__ */ jsx29("div", { className: "hover:bg-info-100 flex cursor-pointer p-2", children: /* @__PURE__ */ jsx29("div", { className: "text-info-700", children: "Back" }) }) }) }),
    /* @__PURE__ */ jsx29(
      NotificationTypeNav,
      {
        id,
        tenant,
        type,
        onChangeShowVariables: setShowVariables
      }
    ),
    /* @__PURE__ */ jsx29(
      MultiColumn2,
      {
        hideLeftBar: true,
        hideRightBar: !showVariables,
        mainContent: /* @__PURE__ */ jsx29(
          NotificationTemplatesContainer,
          {
            id,
            tenant,
            templateType: type,
            onSetExampleJson: setExampleJson,
            fragmentRef: queryRef
          }
        ),
        sideContent: "",
        rightContent: /* @__PURE__ */ jsxs23(Fragment10, { children: [
          /* @__PURE__ */ jsx29("strong", { children: "Details:" }),
          /* @__PURE__ */ jsx29("pre", { children: exampleJson })
        ] })
      }
    )
  ] });
};

// src/meetings/interview-meetings/components/__generated__/InterviewMeeting_meeting.graphql.ts
var node26 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InterviewMeeting_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentType",
      "storageKey": null
    }
  ],
  "type": "CommunicationsInterviewMeeting",
  "abstractKey": null
};
node26.hash = "7f91dc098298a27ed89bad6ad4016072";
var InterviewMeeting_meeting_graphql_default = node26;

// src/meetings/interview-meetings/components/InterviewMeeting.tsx
import { useFragment as useFragment8 } from "react-relay";
import { jsx as jsx30, jsxs as jsxs24 } from "react/jsx-runtime";
var fragmentDef9 = InterviewMeeting_meeting_graphql_default;
var InterviewMeeting = ({ fragmentRef }) => {
  const data = useFragment8(
    fragmentDef9,
    fragmentRef
  );
  return /* @__PURE__ */ jsx30("div", { className: "flex flex-col", children: /* @__PURE__ */ jsxs24("div", { className: "flex items-center gap-2 border-b", children: [
    /* @__PURE__ */ jsx30("div", { children: data.title }),
    /* @__PURE__ */ jsx30("div", { children: data.type }),
    /* @__PURE__ */ jsx30("div", { children: data.sourceType }),
    /* @__PURE__ */ jsx30("div", { children: data.provider })
  ] }) });
};

// src/meetings/interview-meetings/components/__generated__/InterviewMeetingsListQuery.graphql.ts
var node27 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    v1
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v4 = [
    v3,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "InterviewMeetingsListQuery",
      "selections": [
        {
          "args": [
            v1
          ],
          "kind": "FragmentSpread",
          "name": "InterviewMeetingsList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "InterviewMeetingsListQuery",
      "selections": [
        {
          "alias": "list",
          "args": v2,
          "concreteType": "CommunicationsInterviewMeetingsConnection",
          "kind": "LinkedField",
          "name": "communicationsInterviewMeetings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CommunicationsInterviewMeetingsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CommunicationsInterviewMeeting",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v3,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "meetingId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDeleted",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "createdBy",
                      "plural": false,
                      "selections": v4,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "updatedBy",
                      "plural": false,
                      "selections": v4,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "provider",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v2,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "InterviewMeetingsList_list",
          "kind": "LinkedHandle",
          "name": "communicationsInterviewMeetings"
        }
      ]
    },
    "params": {
      "cacheID": "df107cb34badabec4e3715eb8dd89dee",
      "id": null,
      "metadata": {},
      "name": "InterviewMeetingsListQuery",
      "operationKind": "query",
      "text": "query InterviewMeetingsListQuery(\n  $where: CommunicationsInterviewMeetingFilter!\n) {\n  ...InterviewMeetingsList_list_3FC4Qo\n}\n\nfragment InterviewMeetingsList_list_3FC4Qo on Query {\n  list: communicationsInterviewMeetings(first: 10, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        meetingId\n        isDeleted\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        version\n        title\n        description\n        type\n        sourceType\n        contentType\n        provider\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node27.hash = "0a90fc017a59a211a187f6e0f097c6a5";
var InterviewMeetingsListQuery_graphql_default = node27;

// src/meetings/interview-meetings/components/__generated__/InterviewMeetingsListPaginationQuery.graphql.ts
var node28 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }, v4 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedAt": "DESC"
        }
      ]
    },
    v3
  ], v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v6 = [
    v5,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "InterviewMeetingsListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2,
            v3
          ],
          "kind": "FragmentSpread",
          "name": "InterviewMeetingsList_list"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "InterviewMeetingsListPaginationQuery",
      "selections": [
        {
          "alias": "list",
          "args": v4,
          "concreteType": "CommunicationsInterviewMeetingsConnection",
          "kind": "LinkedField",
          "name": "communicationsInterviewMeetings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CommunicationsInterviewMeetingsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CommunicationsInterviewMeeting",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v5,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "meetingId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDeleted",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "createdBy",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountId",
                      "kind": "LinkedField",
                      "name": "updatedBy",
                      "plural": false,
                      "selections": v6,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "provider",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": "list",
          "args": v4,
          "filters": [
            "order",
            "where"
          ],
          "handle": "connection",
          "key": "InterviewMeetingsList_list",
          "kind": "LinkedHandle",
          "name": "communicationsInterviewMeetings"
        }
      ]
    },
    "params": {
      "cacheID": "ff89393d930387d4c89a451590de6291",
      "id": null,
      "metadata": {},
      "name": "InterviewMeetingsListPaginationQuery",
      "operationKind": "query",
      "text": "query InterviewMeetingsListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $where: CommunicationsInterviewMeetingFilter!\n) {\n  ...InterviewMeetingsList_list_3sueo6\n}\n\nfragment InterviewMeetingsList_list_3sueo6 on Query {\n  list: communicationsInterviewMeetings(first: $first, after: $after, order: [{updatedAt: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        code\n        meetingId\n        isDeleted\n        createdAt\n        createdBy {\n          id\n          accountType\n        }\n        updatedAt\n        updatedBy {\n          id\n          accountType\n        }\n        version\n        title\n        description\n        type\n        sourceType\n        contentType\n        provider\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node28.hash = "37b06e1b68e4a559463ebda6aece131d";
var InterviewMeetingsListPaginationQuery_graphql_default = node28;

// src/meetings/interview-meetings/components/__generated__/InterviewMeetingsList_list.graphql.ts
var node29 = function() {
  var v0 = [
    "list"
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = [
    v1,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountType",
      "storageKey": null
    }
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": InterviewMeetingsListPaginationQuery_graphql_default
      }
    },
    "name": "InterviewMeetingsList_list",
    "selections": [
      {
        "alias": "list",
        "args": [
          {
            "kind": "Literal",
            "name": "order",
            "value": [
              {
                "updatedAt": "DESC"
              }
            ]
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
          }
        ],
        "concreteType": "CommunicationsInterviewMeetingsConnection",
        "kind": "LinkedField",
        "name": "__InterviewMeetingsList_list_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CommunicationsInterviewMeetingsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CommunicationsInterviewMeeting",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  v1,
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDeleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountId",
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": v2,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountId",
                    "kind": "LinkedField",
                    "name": "updatedBy",
                    "plural": false,
                    "selections": v2,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contentType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "provider",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node29.hash = "37b06e1b68e4a559463ebda6aece131d";
var InterviewMeetingsList_list_graphql_default = node29;

// src/meetings/interview-meetings/components/InterviewMeetingsList.tsx
import { Suspense as Suspense10, useCallback as useCallback8, useState as useState14 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery10, usePaginationFragment as usePaginationFragment2 } from "react-relay";
import { formatDistanceToNow, parseISO } from "date-fns";
import {
  DefaultListLayoutItemHeader,
  DefaultListLayoutSectionElement,
  EdSkeleton as EdSkeleton4,
  Input as Input3,
  ListLayout,
  PageHeading
} from "shared-ui";
import { isNotNullOrUndefined as isNotNullOrUndefined3, useDebounce as useDebounce4 } from "shared-lib";
import { jsx as jsx31, jsxs as jsxs25 } from "react/jsx-runtime";
var queryDef9 = InterviewMeetingsListQuery_graphql_default;
var fragmentDef10 = InterviewMeetingsList_list_graphql_default;
function createLinkTo(section) {
  const code = section.context.code;
  return `../../../view/${code}`;
}
var List = ({ fragmentRef }) => {
  const { data, loadNext } = usePaginationFragment2(fragmentDef10, fragmentRef);
  const onLoadNext = useCallback8(() => {
    loadNext(10);
  }, [loadNext]);
  const { list } = data;
  const sections = (list?.edges || []).map((e) => e.node).filter(isNotNullOrUndefined3).map((e) => {
    const name = `${e.title}`;
    return {
      key: e.code.toString(),
      itemTitle: name,
      listTitle: /* @__PURE__ */ jsx31("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs25("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsx31("div", { className: "text-md font-medium uppercase", children: name }),
        /* @__PURE__ */ jsx31("div", { className: "text-md text-blue-500", children: e.code })
      ] }) }),
      description: /* @__PURE__ */ jsxs25("div", { className: "pt-2 text-sm", children: [
        "Created ",
        formatDistanceToNow(parseISO(e.createdAt))
      ] }),
      hideIcon: true,
      icon: () => null,
      iconForeground: "text-primary-700",
      iconBackground: "bg-primary-50",
      context: {
        code: e.code
      },
      element: /* @__PURE__ */ jsx31(DefaultListLayoutSectionElement, { children: /* @__PURE__ */ jsx31("div", { className: "grid", children: /* @__PURE__ */ jsx31("div", { children: e.code }) }) })
    };
  });
  return /* @__PURE__ */ jsx31(Suspense10, { fallback: /* @__PURE__ */ jsx31(EdSkeleton4, {}), children: /* @__PURE__ */ jsx31(
    ListLayout,
    {
      sections,
      itemHeader: (s) => /* @__PURE__ */ jsx31(
        DefaultListLayoutItemHeader,
        {
          title: "Tenants",
          to: createLinkTo,
          section: s
        }
      ),
      loadMore: onLoadNext,
      isLoading: false
    }
  ) });
};
var MeetingsListLoader = ({ where }) => {
  const query = useLazyLoadQuery10(
    queryDef9,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx31("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx31("div", { className: "flex-1", children: /* @__PURE__ */ jsx31(Suspense10, { fallback: /* @__PURE__ */ jsx31(EdSkeleton4, {}), children: /* @__PURE__ */ jsx31(List, { fragmentRef: query }) }) }) });
};
var InterviewMeetingsList = ({ employerId }) => {
  const [filter, setFilter] = useState14(null);
  const searchTerm = useDebounce4(filter, 500);
  let where = null;
  if (employerId) {
    where = {
      employerId: { eq: employerId }
    };
  }
  if (searchTerm) {
    if (!where) {
      where = { title: { startsWith: filter } };
    } else {
      where.and = [{ title: { startsWith: filter } }];
    }
  }
  return /* @__PURE__ */ jsxs25("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx31("div", { className: "flex items-center justify-between gap-2 border-b", children: /* @__PURE__ */ jsxs25("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx31(PageHeading, { children: "Interview Meetings" }),
      /* @__PURE__ */ jsxs25("div", { className: "flex items-center space-x-4 py-2", children: [
        /* @__PURE__ */ jsx31("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
        /* @__PURE__ */ jsx31("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx31(
          Input3,
          {
            placeholder: " Name ",
            name: "filter",
            onValueChange: (filter2) => setFilter(filter2)
          },
          "filter"
        ) })
      ] })
    ] }) }),
    where && /* @__PURE__ */ jsx31(MeetingsListLoader, { where })
  ] });
};
export {
  AnyNotificationType,
  AnyTenant,
  DefaultNotificationTemplateEditor,
  EmailNotificationItem,
  EmailNotificationsList,
  EmailNotificationsListContainer,
  EmailTemplateContainer,
  EmailTemplateCreateButton,
  EmailTemplateEditPreview,
  EmailTemplateEditor,
  EmailTemplateLayout,
  EmailTemplatePreview,
  EmailTemplateRow,
  EmailTemplateRowColumns,
  EmailTemplateSelector,
  EmailTemplateTypeCreateList,
  EmailTemplateTypesSelect,
  EmailTemplateVersions,
  EmailTemplatesList,
  EmailTemplatesListContainer,
  EmailTemplatesTable,
  InterviewMeeting,
  InterviewMeetingsList,
  MeetingsListLoader,
  NotificationCreateLayout,
  NotificationTemplatesContainer,
  NotificationTemplatesList,
  NotificationTypeLayout,
  NotificationTypeNav,
  NotificationTypeTemplatesList,
  NotificationTypesSelect,
  RenderingEngineTypesSelect,
  TenantSelect,
  TenantSelectContainer,
  editableEmailTemplateTypes,
  emailTemplateTypes,
  queryDef5 as queryDef
};
/*! Bundled license information:

lodash/lodash.js:
  (**
   * @license
   * Lodash <https://lodash.com/>
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)

lodash-es/lodash.js:
  (**
   * @license
   * Lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="es" -o ./`
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)
*/
//# sourceMappingURL=index.mjs.map